import * as angular from "angular";
import {IController, IQService} from "angular";
import {VisitPlanModel} from "../../models/visit-plan.model";
import {VisitPlanAccountModel} from "../../models/visit-plan-account.model";
import {VisitPlanFacadeService} from "../../angular/services/visit-plan-facade.service";
import {finalize, skip, Subscription, firstValueFrom, Observable, forkJoin, map} from "rxjs";
import {VisitPlanAccountFacadeService} from "../../angular/services/visit-plan-account-facade.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {VisitPlanCellModel} from "../../models/visit-plan-cell.model";
import {SchedulingProjectDialogService} from "../../services/scheduling-project-dialog.service";
import {ServiceType} from "../../../deliveries/types/service.type";
import {VisitPlanStatusEnum} from "../../enums/visit-plan-status.enum";
import * as _ from "lodash";
import {isUndefined} from "lodash";
import {AgentsService} from "../../../agents/services/agents-service.service";
import {VisitScheduleResourceModel} from "../../models/visit-schedule-resource.model";
import {VisitScheduleResourcesParamsModel} from "../../models/visit-schedule-params.model";
import {VisitScheduleModel} from "../../models/visit-schedule.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {VisitPlanScheduleStatusEnum} from "../../enums/visit-plan-schedule-status.enum";
import {VisitPlanScheduleFacadeService} from "../../angular/services/visit-plan-schedule-facade.service";
import {CommonsFacadeService} from "../../../commons/angular/state/commons/commons-facade.service";
import {SchedulingProjectAlertsService} from "../../services/scheduling-project-alerts.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {PlanningPanelModel} from "../../../planning/models/planning-panel.model";
import {AgentModel} from "../../../agents/angular/models/agent.model";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {VisitScheduleDayModel} from "../../models/visit-schedule-day.model";
import {VisitPlanHttpService} from "../../angular/services/visit-plan-http.service";
import {VisitScheduleFacadeService} from "../../angular/services/visit-schedule-facade.service";
import {VisitScheduleStatusEnum} from "../../enums/visit-schedule-status.enum";
import {PanelService} from "../../../commons/angular/services/panel.service";
import {
  VisitPlanAccountSortingDialogComponent
} from "../../angular/components/visit-plan-account-sorting-dialog/visit-plan-account-sorting-dialog.component";
import {
  OptimizationDaySelectDialogComponent
} from "../../angular/components/optimization-day-select-dialog/optimization-day-select-dialog.component";
import {VisitPlanDayTotalsModel} from "../../models/visit-plan-day-totals.model";
import {VisitPlanAccountAnalysisModel} from "../../models/visit-plan-account-analysis.model";
import {VisitScheduleOptimizationSettings} from "../../models/visit-schedule-optimization-config.model";
import {VisitScheduleRefreshParams} from "../../models/visit-schedule-refresh-params.model";
import {
  AutoDispatchTimeRange,
  VisitScheduleDispatchSettingsModel
} from "../../models/visit-schedule-dispatch-settings.model";
import {
  buildAutoDispatchTimeRanges,
  findAutoDispatchTimeRange
} from "../../models/visit-schedule-dispatch-settings.functions";
import {
  isVisitScheduleDayDispatched,
  isVisitScheduleDayDispatchedById
} from "../../models/visit-schedule-day.functions";
import {
  isVisitPlanRouteBlocked,
  isVisitPlanRouteDispatched
} from "../../models/visit-plan-route.functions";

import {TagType} from "../../../tags/angular/types/tag.type";
import {BreadcrumbsService} from "../../../commons/angular/services/breadcrumbs.service";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {
  VisitPlanTableColumnFilterDialogComponent
} from "../../angular/components/visit-plan-table-column-filter-dialog/visit-plan-table-column-filter-dialog.component";
import {
  VisitPlanScheduleResourceSelectListComponent
} from "../../angular/components/visit-plan-schedule-resource-select-list/visit-plan-schedule-resource-select-list.component";
import * as moment from "moment/moment";
import {ResourceUtilizationModel} from "../../models/resource-utilization.model";
import {VisitScheduleAnalysisModel} from "../../models/visit-schedule-analysis.model";
import {VisitScheduleRoutesChannelService} from "../../angular/services/visit-schedule-routes-channel.service";
import {VisitPlanCallModel} from "../../models/visit-plan-call.model";
import {RecurrencePatternModel} from "../../models/recurrence-pattern.model";
import {
  VisitPlanTrackerCallRecurringConfigurationOptionsModel
} from "../../models/visit-plan-tracker-call-recurring-configuration-options.model";
import {VisitScheduleRouteOptimizeRequestModel} from "../../models/visit-schedule-route-optimize-request.model";
import {BringozToastService} from "../../../commons/services/bringoz-toast.service";
import {
  VisitPlanScheduleRouteReassignmentComponent
} from "../../angular/components/visit-plan-schedule-route-reassignment/visit-plan-schedule-route-reassignment.component";
import {
  VisitPlanRoutesPanelContextMenuComponent
} from "../../angular/components/visit-plan-routes-panel-context-menu/visit-plan-routes-panel-context-menu.component";
import {
  VisitPlanAutoDispatchDialogComponent
} from "../../angular/components/visit-plan-auto-dispatch-dialog/visit-plan-auto-dispatch-dialog.component";
import {CellEditDialogComponent} from "../../angular/components/cell-edit-dialog/cell-edit-dialog.component";
import {InsightEntityType, RecommendationHolderType} from "../../../recommendation/models/recommendation.model";
import {VisitScheduleResourceHoldersParamsModel} from "../../models/visit-schedule-resource-holders-params.model";
import {ResourceHoldersPaginationDataModel} from "../../models/resource-holders-pagination-data.model";
import {AccountsService} from "../../../account/services/accounts-service.service";
import {AccountsHttpService} from "../../../account/angular/services/accounts-http.service";
import {IAMPermissionsService} from "../../../../permission/iamPermissions.service";
import {ProcessTrackingTypeEnum} from "../../../commons/types/process-tracking-type.enum";
import {RecoveryActionEnum} from "../../../batch/enums/recovery-action.enum";
import {BatchTypeEnum} from "../../../batch/enums/batch-type.enum";
import {VisitPlanProcessingDialogResultModel} from "../../models/visit-plan-processing-dialog-result.model";
import {VisitPlanCphSummaryModel} from "../../models/visit-plan-cph-summary.model";
import {
  VisitPlanAuditLogComponent
} from "../../angular/components/visit-plan-audit-log/visit-plan-audit-log.component";

export class VisitPlanViewComponent implements IController {

  visitPlanId: string;

  visitScheduleFrom?: any;
  visitScheduleTo?: any;
  selectedQuickFilterId?: string;
  visitScheduleSize?: number;
  visitSchedulePage?: number;
  jobs: any[];
  // visitPlanRoutes: any[];


  public filtersConfig: { visitPlan?, visitSchedule? } = {}
  public accounts: VisitPlanAccountModel[];
  public programTypeAliasMap: { [key: string]: string };
  public visitPlanSubscription: Subscription;
  public visitPlanAccountsSubscription: Subscription;
  public visitPlanAccountsLoadingSubscription: Subscription;
  public visitPlanAccountsInitializedSubscription: Subscription;
  public panelJobsSubscription: Subscription;
  public routesSubscription: Subscription;

  public visitPlan: VisitPlanModel;
  public isLoadingAccounts: boolean = false;
  public isInitializedAccounts: boolean = false;
  public serviceTypeOptions: typeof ServiceType = ServiceType;
  public visitPlanStatuses: typeof VisitPlanStatusEnum = VisitPlanStatusEnum;
  public currentUserId: string;
  public isNotSynced: boolean = false;
  public panels: any[] = [];
  public panelJobs: any[] = [];

  // Visit Schedule
  public visitPlanRoutes: any[];
  public isLoadingRoutes: boolean = false;
  public visitSchedule?: VisitScheduleModel;
  public visitScheduleDays?: VisitScheduleDayModel[];
  public projectVisitScheduleDays: VisitScheduleDayModel[];
  public resourceHoldersPaginationData?: ResourceHoldersPaginationDataModel;
  public agentsPaginationPages: number[];
  public resources: VisitScheduleResourceModel[];
  public visitScheduleTimelineEnabled: boolean = true;
  public visitPlanScheduleStatuses: typeof VisitPlanScheduleStatusEnum = VisitPlanScheduleStatusEnum;
  public routes: any[] = [];

  public visitScheduleSubscription: Subscription;
  public visitScheduleResourcesSubscription: Subscription;
  public isJobsPanelOpen: boolean;
  public resizeObserver: any;
  public checkVisitPlanViewPort: number;
  public mapRoutes: any[];
  public isMapView: boolean;
  // public mapViewStartRange: number;
  // public mapViewEndRange: number;
  // public dispatchViewStartRange: number;
  // public dispatchViewEndRange: number;
  public agentColorMap: { [key: string]: string };
  public colorPallet: any;
  public isPublished: boolean;
  public isDispatchView: boolean;
  public mapVisitScheduleDays: VisitScheduleDayModel[];
  public dispatchVisitScheduleDays: VisitScheduleDayModel[];
  public visitScheduleLoadingStateSubscription: Subscription;
  public isLoadingVisitSchedule: boolean;
  public visitScheduleStatuses: typeof VisitScheduleStatusEnum = VisitScheduleStatusEnum;
  public selectedJobIds: string[] = [];
  public accountSortBy: string = 'accountName';
  public accountSortByType: string = 'asc';
  public timezone: string;
  public schedulingProjectDays: VisitScheduleDayModel[];
  public visitPlanDayTotals: VisitPlanDayTotalsModel[];
  public visitPlanInitialDayTotals: VisitPlanDayTotalsModel[];
  public overallDayTotals: VisitPlanDayTotalsModel[];
  public visitPlanAccountsAnalysisSubscription: Subscription;
  public visitPlanAccountTotalsSubscription: Subscription;
  public visitPlanAccountsAnalysis: VisitPlanAccountAnalysisModel[];
  public isReloadPanelsData: boolean;
  public isVisitScheduleFullyExpanded: boolean;
  public totalDeliveryDays: number = 0;
  public totalUnits: number = 0;
  public totalVisits: number = 0;
  public totalServiceTime: number = 0;
  public totalServiceTimeFormatted: string = '';
  public serviceTimeMapByProgramType = {};
  public totalRouteTime: {
    planned: string;
    travelTime: string;
    serviceTime: string;
    idleTime: string;
  }
  private pendingAnalysisRefresh: boolean = false;
  public pageName: string;
  public programTypesMap: any;
  public totalCPH: number = 0;
  public mainCph: number = undefined;
  public targetCPH: number = undefined;
  public hiddenRoutesAgentIds: string[] = [];
  public resourcesUtilization?: ResourceUtilizationModel[];
  public visitScheduleAnalysis: VisitScheduleAnalysisModel;
  public selectedRouteIds: string[] = [];
  public readonly holderType = RecommendationHolderType.VisitPlan;
  public readonly entityType = InsightEntityType.VisitAccount;
  public generateRecommendationsAllowed: boolean = false;
  public isSyncVisitPlanAndScheduleFilters: boolean = true;

  public autoDispatchEnabledUi: boolean = false;
  public autoDispatchTimeRanges: AutoDispatchTimeRange[] = buildAutoDispatchTimeRanges();
  public autoDispatchSavedRange: AutoDispatchTimeRange;
  public autoDispatchSaving: boolean = false;

  public tableFilterColumns = {
    isDisplayDeliveryEtd: true,
    isDisplayDeliveryUnits: true,
    isDisplayCallTypes: true,
    isDisplayServiceTime: true,
    isDisplayDeliveryDays: true,
  };
  private _routePanelContextMenuSubscription?: Subscription;
  private _reassignRoutePanelSubscription?: Subscription;
  private _deleteCallsResultSubscription?: Subscription;
  private _updateCallsTimeWindowResultSubscription?: Subscription;
  private _updateCellTrackerResultSubscription?: Subscription;
  // The sync process can finish before the processing dialog tracks it, so its result may not include it
  private _isDeliveryDetailsSyncRequested = false;

  constructor(private visitPlanFacadeService: VisitPlanFacadeService, private visitPlanAccountFacadeService: VisitPlanAccountFacadeService,
              private $timeout, private splitService: SplitService, private dateRangeTimeFiltersService: DateRangeTimeFiltersService,
              private schedulingProjectDialogService: SchedulingProjectDialogService, private agentsService: AgentsService, private UserService,
              private visitPlanScheduleFacadeService: VisitPlanScheduleFacadeService, private commonsFacadeService: CommonsFacadeService,
              private schedulingProjectAlertsService: SchedulingProjectAlertsService, private $element, private moment, private confirmDialogService: ConfirmDialogService,
              private commonsService: CommonsService, private commonsConstants, private visitPlanHttpService: VisitPlanHttpService,
              private visitScheduleFacadeService: VisitScheduleFacadeService, private TimelineService, private panelService: PanelService,
              private bringozLoaderService, private commonsAlertsService: CommonsAlertsService, private $log, private breadcrumbsService: BreadcrumbsService, private $state,
              private $filter, private visitScheduleRoutesChannelService: VisitScheduleRoutesChannelService, private bringozToastService: BringozToastService,
              private accountsService: AccountsService, private accountsHttpService: AccountsHttpService, private IAMPermissions: IAMPermissionsService, private $q: IQService
  ) {
    this.pageName = $state.current.name;
    this.programTypesMap = this.splitService.getSiteProgramTypesMap();
  }

  $onInit() {

    console.count('VisitPlanViewComponent $onInit');

    this.breadcrumbsService.off();

    this.currentUserId = this.UserService.getCurrentUser().id;

    this.colorPallet = this.commonsConstants.colorPalletTwo;

    this.generateRecommendationsAllowed = this.IAMPermissions.hasPermission('recommendation.generate');

    this.visitPlanSubscription = this.visitPlanFacadeService.selectOne(this.visitPlanId)
      .subscribe((visitPlan: VisitPlanModel) => {

        console.count('visitPlanSubscription emitted');

        if (!!visitPlan) {

          if (!this.timezone) {
            this.moment.tz.setDefault(visitPlan.zoneId);
            this.timezone = visitPlan.zoneId;
          }
          if (visitPlan.status === this.visitPlanStatuses.Processing || visitPlan.status === this.visitPlanStatuses.Import) {
            const processingDialog = this.schedulingProjectDialogService.visitPlanProcessingDialog(visitPlan);
            processingDialog?.then((result: VisitPlanProcessingDialogResultModel) => {
              if (this._handleProcessingDialogCancel(result)) {
                return;
              }

              const data = result?.processes;

              if (data?.includes(ProcessTrackingTypeEnum.SchedulingProjectBulkDeleteCalls)
                || data?.includes(ProcessTrackingTypeEnum.SchedulingProjectBulkDeleteDeliveries)) {
                this._getVisitPlanAccounts();
                this._getVisitPlanAccountTotalsWithoutFilters();
              }
              if (this._isDeliveryDetailsSyncRequested || result?.batchTypes?.includes(BatchTypeEnum.UpdateDeliveryData)) {
                this._isDeliveryDetailsSyncRequested = false;
                this.schedulingProjectAlertsService.updateDeliveryDataSuccess();
                this._maybeAutoRecalcAfterPullingActualData();
              }
            });
          }

          if (!isUndefined(this.visitPlan) && this.visitPlan.hasNotSyncedChanges === true && !visitPlan.hasNotSyncedChanges) {
            this.visitPlanAccountFacadeService.clearCellTrackers();
          }

          const isTrackerUpdatedByCurrentUser = visitPlan.trackerUpdatedById === this.currentUserId;

          if (visitPlan.trackerUpdatedById && !isTrackerUpdatedByCurrentUser && visitPlan.hasNotSyncedChanges) {
            this.isNotSynced = true;
          }

          if (!this.filtersConfig.visitPlan) {
            this.filtersConfig.visitPlan = {
              range: {dateStart: visitPlan.from, dateEnd: visitPlan.to},
              queryString: undefined,
              includeFilters: [
                SiteFiltersType.branchIds,
                SiteFiltersType.accountIds,
                // SiteFiltersType.serviceAreaIds,
                SiteFiltersType.segment,
                SiteFiltersType.states
              ],
              bringozFilters: {
                [SiteFiltersType.branchIds]: [],
                [SiteFiltersType.accountIds]: [],
                [SiteFiltersType.serviceAreaIds]: [],
                [SiteFiltersType.segment]: undefined,
                [SiteFiltersType.states]: []
              },
              optionIdsMap: {
                [SiteFiltersType.branchIds]: visitPlan.branchIds,
              }
            }
          }


          if (!this.visitPlan) {
            this._getProjectVisitScheduleDaysData(visitPlan);
            // this._getSchedulingProjectDays(visitPlan);

            if (!this.jobs) {
              this.jobs = [];
            }

            if (visitPlan.scheduleStatus === 'PLANNED') {
              this._getJobs(visitPlan);
            }
          }

          if ((this.visitPlan?.slotsImportCompleted !== visitPlan.slotsImportCompleted) && visitPlan.slotsImportCompleted) {
            this._getVisitPlanAccounts();
            this._getVisitPlanAccountTotalsWithoutFilters();
          }

          if (this.visitPlan?.status === this.visitPlanStatuses.Processing && visitPlan.status === this.visitPlanStatuses.Ongoing) {
            this._getVisitPlanAccounts();
            this._getVisitPlanAccountTotalsWithoutFilters();
            this._getVisitPlanAccountTotals(this._getQueryTotalsWithLimitPayload());
          }

          if (this.visitPlan?.scheduleStatus === 'NOT_PLANNED' && visitPlan.scheduleStatus === 'PLANNED') {
            this._getJobs(visitPlan);
          }

          if (!!this.visitPlan &&
            !!visitPlan.resourcesImportCompleted &&
            !!visitPlan.slotsImportCompleted &&
            ( (!this.visitPlan.resourcesImportCompleted && !!visitPlan.resourcesImportCompleted) || (!this.visitPlan.slotsImportCompleted && !!visitPlan.slotsImportCompleted) )
          ) {
            this._getResourcesUtilization();
          }

          if (visitPlan.scheduleId) {

            if (!this.filtersConfig.visitSchedule) {
              this.filtersConfig.visitSchedule = {
                range: {dateStart: visitPlan.from, dateEnd: visitPlan.to},
                queryString: undefined,
                page: this.visitSchedulePage,
                size: this.visitScheduleSize,
                includeFilters: [
                  SiteFiltersType.branchIds,
                  SiteFiltersType.agentIds,
                  SiteFiltersType.tags,
                  SiteFiltersType.agentSource
                ],
                bringozFilters: {
                  [SiteFiltersType.branchIds]: [],
                  [SiteFiltersType.agentIds]: [],
                  [SiteFiltersType.tags]: [],
                  [SiteFiltersType.agentSource]: undefined
                },
                optionIdsMap: {
                  [SiteFiltersType.branchIds]: visitPlan.branchIds,
                },
                queryMap: {
                  tagType: [TagType.Agent]
                }
              }
            }

            if ((!this.visitPlan && visitPlan.scheduleStatus === 'PLANNED') ||
              (this.visitPlan?.scheduleStatus === 'NOT_PLANNED' && visitPlan.scheduleStatus === 'PLANNED')) {
              this._setVisitSchedule(visitPlan);
            }
          }

          this.visitPlan = visitPlan;

          // if (!this.visitSchedule && this.visitPlan.scheduleStatus === 'PLANNED') {
          //   this._initVisitScheduleSubscription();
          // }

          if (!this.visitSchedule) {
            this._initVisitScheduleSubscription();
          }

          this.$timeout(() => {
          }, 0);
        }
      });

    this.visitPlanFacadeService.subscribeToChannels();

    this.visitPlanAccountFacadeService.subscribeToChannels();

    this.programTypeAliasMap = this.splitService.getProgramCodesMap();

    this.visitPlanAccountsSubscription = this.visitPlanAccountFacadeService.selectAll()
      .subscribe((visitPlanAccounts: VisitPlanAccountModel[]) => {
        console.count('visitPlanAccountsSubscription emitted');

        if (!!visitPlanAccounts) {
          this.accounts = angular.copy(visitPlanAccounts);
          if (this.pendingAnalysisRefresh) {
            this.pendingAnalysisRefresh = false;
            this._syncVisitPlanAccountAnalysis();
          }
          this.$timeout(() => {
          }, 0);
        }
      })

    this.visitPlanAccountsAnalysisSubscription = this.visitPlanAccountFacadeService.selectVisitPlanAccountAnalysis()
      .subscribe((visitPlanAccountsAnalysis: VisitPlanAccountAnalysisModel[]) => {
        console.count('visitPlanAccountsAnalysisSubscription emitted');

        if (!!visitPlanAccountsAnalysis) {
          this.visitPlanAccountsAnalysis = angular.copy(visitPlanAccountsAnalysis);
          this.$timeout(() => {
          }, 0);
        }
      })

    this.visitPlanAccountsLoadingSubscription = this.visitPlanAccountFacadeService.selectIsLoading().subscribe((isLoading: boolean) => {
      console.count('visitPlanAccountsLoadingSubscription emitted');

      this.isLoadingAccounts = isLoading;
      this.$timeout(() => {
      }, 0);
    })

    this.visitPlanAccountsInitializedSubscription = this.visitPlanAccountFacadeService.selectInitialized().subscribe((isInitialized: boolean) => {
      this.isInitializedAccounts = isInitialized;
      this.$timeout(() => {
      }, 0);
    })

    this.panelJobsSubscription = this.visitPlanScheduleFacadeService.selectAllJobs().subscribe(jobs => {
      console.count('panelJobsSubscription emitted');
      this.panelJobs = jobs;
    })

    this._deleteCallsResultSubscription = this.visitPlanAccountFacadeService.onDeleteCallsFromCellResult()
      .subscribe((isSuccess) => {
        isSuccess ?
          this.schedulingProjectAlertsService.deleteCallsSuccess() :
          this.schedulingProjectAlertsService.deleteCallsError();
      })

    this._updateCallsTimeWindowResultSubscription = this.visitPlanAccountFacadeService.onUpdateCallsTimeWindowResult()
      .subscribe((isSuccess) => {
        if (isSuccess) {
          this.schedulingProjectAlertsService.moveDayCallsSuccess();
          this._getVisitPlanAccounts();
        } else {
          this.schedulingProjectAlertsService.moveDayCallsError();
        }
      })

    this._updateCellTrackerResultSubscription = this.visitPlanAccountFacadeService.onUpdateCellTrackerResult()
      .subscribe((isSuccess) => {
        if (isSuccess) {
          // this._getVisitPlanAccounts();

          // the reducer already merges the returned tracker into the account row — only footer totals need refreshing
          this._getVisitPlanAccountTotals(this._getQueryWithLimitPayload());
        }
      })

    this._getVisitPlanAccountTotalsWithoutFilters();

  }


  $onDestroy() {

    console.count('VisitPlanViewComponent $onDestroy');

    this.breadcrumbsService.on();

    //reset site timezone to original tz
    const timezone = this.splitService.getSelectedTimeZone();
    this.splitService.setSelectedTimeZone(timezone);

    this.resizeObserver?.disconnect();
    this.visitPlanSubscription.unsubscribe();
    this.visitPlanAccountsSubscription.unsubscribe();
    this.visitPlanAccountsLoadingSubscription.unsubscribe();
    this.visitPlanAccountsInitializedSubscription?.unsubscribe();
    this.visitPlanAccountsAnalysisSubscription?.unsubscribe();
    this.visitPlanAccountTotalsSubscription?.unsubscribe();



    this.visitPlanFacadeService.unsubscribeFromChannels();
    this.visitPlanFacadeService.clearStore();


    this.visitPlanAccountFacadeService.unsubscribeFromChannels();
    this.visitPlanAccountFacadeService.clearStore();

    this.visitScheduleResourcesSubscription?.unsubscribe();

    this.visitScheduleSubscription?.unsubscribe();
    this.visitScheduleFacadeService.clearStore();
    this.visitScheduleLoadingStateSubscription?.unsubscribe();

    this.panelJobsSubscription.unsubscribe();

    if (this.routesSubscription) {
      this.routesSubscription.unsubscribe();
      this.visitScheduleRoutesChannelService.unsubscribeChannel();
    }
    this._routePanelContextMenuSubscription?.unsubscribe();
    this._reassignRoutePanelSubscription?.unsubscribe();
    this._deleteCallsResultSubscription?.unsubscribe();
    this._updateCallsTimeWindowResultSubscription?.unsubscribe();
    this._updateCellTrackerResultSubscription?.unsubscribe();
  }


  fetchNext() {
    if (this.isLoadingAccounts) return;
    this.visitPlanAccountFacadeService.fetchNext(this.visitPlanId, this._getQueryWithLimitPayload());
  }

  onBackToProjects() {
    this.$state.go('scheduling-project.visit-plans.table');
  }

  /**
   * A deleted (archived) project is read only.
   * The accounts table, the timeline and the panels emit their mutations upwards, so guarding the
   * handlers here blocks most of the editing surface even if a control was missed in the template.
   * This is NOT sufficient on its own: components that call a mutating service directly must block
   * on isArchive themselves, because this guard would only run after the write. Today those are the
   * cell edit dialog (visit-plan-accounts-table-row-cell), the resource select list
   * (visit-plan-panels.onAssign) and the dispatch view (blocked by not letting it open).
   * Returns true when the action has been blocked.
   */
  isActionBlocked(): boolean {
    if (!this.visitPlan?.isArchive) return false;
    this.schedulingProjectAlertsService.deletedProjectActionBlocked();
    return true;
  }

  onEditVisitPlanName() {
    if (this.isActionBlocked()) return;

    this.schedulingProjectDialogService.editVisitPlanName(this.visitPlan)
      .then((updatedVisitPlan: VisitPlanModel) => {
        this.commonsFacadeService.setLoaderOn();
        this.visitPlanFacadeService.updateVisitPlanName(updatedVisitPlan)
          .subscribe({
            next: (updatedVisitPlan: VisitPlanModel) => {
              this.schedulingProjectAlertsService.updateVisitPlanSuccess();
              // Store update will trigger subscription, so no need to manually update local state
            },
            error: () => {
              this.schedulingProjectAlertsService.updateVisitPlanError();
              this.commonsFacadeService.setLoaderOff();
            },
            complete: () => {
              this.commonsFacadeService.setLoaderOff();
            }
          });
      })
      .catch(() => {});
  }

  onSyncVisitPlan() {
    this._getVisitPlanAccounts();
    this.$timeout(() => {
      this.isNotSynced = false;
      this.schedulingProjectAlertsService.syncVisitPlanSuccess();
    }, 1000);
  }

  onSyncVisitPlanAccounts() {
    if (this.isActionBlocked()) return;

    this.commonsFacadeService.setLoaderOn();
    const siteId = this.splitService.getSiteId();
    this.visitPlanHttpService.syncVisitPlanAccounts(this.visitPlanId, siteId)
      .pipe(
        finalize(() => {
          this.commonsFacadeService.setLoaderOff();
        })
      )
      .subscribe({
        next: () => {
          const dialog = this.schedulingProjectDialogService.visitPlanProcessingDialog(this.visitPlan);

          dialog?.then((result: VisitPlanProcessingDialogResultModel) => {
            if (this._handleProcessingDialogCancel(result)) {
              return;
            }

            this._completeSyncVisitPlanAccounts();
          }, () => this._completeSyncVisitPlanAccounts());
        },
        error: () => {
          this.schedulingProjectAlertsService.syncVisitPlanAccountsError();
        }
      });
  }

  private _completeSyncVisitPlanAccounts() {
    this.schedulingProjectAlertsService.syncVisitPlanAccountsSuccess();
    this._getVisitPlanAccounts();
  }

  onImportVisitPlanAccounts(event: Event) {
    if (this.isActionBlocked()) return;

    this.schedulingProjectDialogService.importVisitPlanAccounts(this.visitPlanId, event)
      .then((result: {imported?: boolean}) => {
        if (result?.imported) {
          this._getVisitPlanAccounts();
          this._getVisitPlanAccountTotalsWithoutFilters();
        }
      })
      .catch(() => {});
  }

  onGenerateVisitSchedule(event) {
    if (this.isActionBlocked()) return;

    let dialogData = {tabs: ['hardConstraints', 'softConstraints']};

    // Check if we have a template reference
    const templateReference = this.visitSchedule?.['schedulingProjectTemplateReference'] ||
                             this.visitPlan?.['schedulingProjectTemplateReference'];

    if (templateReference?.id) {
      // Fetch template and use its settings
      this.visitPlanHttpService.getTemplate(templateReference.id).subscribe({
        next: (template) => {
          if (template?.visitScheduleOptimizationSettings) {
            dialogData['visitScheduleOptimizationSettings'] = template.visitScheduleOptimizationSettings;
            dialogData['visitScheduleResourceSettings'] = template.visitScheduleResourceSettings;
          } else if (this.visitSchedule && this.visitSchedule['visitScheduleOptimizationSettings']) {
            // Fallback to existing visit schedule settings if template doesn't have them
            dialogData['visitScheduleOptimizationSettings'] = this.visitSchedule['visitScheduleOptimizationSettings'];
          }

          const hasPermissionToEdit = this.IAMPermissions.hasPermission('schedulingProject.optimization.update');
          const functionRef = !!hasPermissionToEdit ?
            this.schedulingProjectDialogService.createOptimizeVisitScheduleFormDialog(event, dialogData) :
            this.$q.when({ visitScheduleOptimizationSettings: template.visitScheduleOptimizationSettings });

          functionRef
            .then((visitScheduleOptConfig) => {
              if (!!visitScheduleOptConfig) {
                this.visitPlanFacadeService.initVisitSchedule(this.visitPlanId, visitScheduleOptConfig.visitScheduleOptimizationSettings)
              }
            });
        },
        error: (err) => {
          console.error('Failed to load template', err);
          // Fallback to existing visit schedule settings if template fetch fails
          if (this.visitSchedule && this.visitSchedule['visitScheduleOptimizationSettings']) {
            dialogData['visitScheduleOptimizationSettings'] = this.visitSchedule['visitScheduleOptimizationSettings'];
          }


          this.schedulingProjectDialogService
            .createOptimizeVisitScheduleFormDialog(event, dialogData)
            .then((visitScheduleOptConfig) => {
              if (!!visitScheduleOptConfig) {
                this.visitPlanFacadeService.initVisitSchedule(this.visitPlanId, visitScheduleOptConfig.visitScheduleOptimizationSettings)
              }
            });
        }
      });
    } else {
      // No template reference, use existing visit schedule settings
      if (this.visitSchedule && this.visitSchedule['visitScheduleOptimizationSettings']) {
        dialogData['visitScheduleOptimizationSettings'] = this.visitSchedule['visitScheduleOptimizationSettings'];
      }

      this.schedulingProjectDialogService
        .createOptimizeVisitScheduleFormDialog(event, dialogData)
        .then((visitScheduleOptConfig) => {
          if (!!visitScheduleOptConfig) {
            this.visitPlanFacadeService.initVisitSchedule(this.visitPlanId, visitScheduleOptConfig.visitScheduleOptimizationSettings)
          }
        });
    }
  }

  onSubmitVisitPlanQuery(query) {
    this.filtersConfig.visitPlan.queryString = query;
    this._getVisitPlanAccounts();
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filtersConfig.visitPlan.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    const reloadVisitSchedule = !!this.filtersConfig.visitSchedule &&
      !_.isEqual(this.filtersConfig.visitPlan.bringozFilters.serviceAreaIds, filters.serviceAreaIds);

    this.filtersConfig.visitPlan.bringozFilters = filters;
    this.selectedQuickFilterId = selectedQuickFilter?.id;

    if (this.isSyncVisitPlanAndScheduleFilters) {
      const isSyncNeeded = this._isSyncVisitPlanAndScheduleFiltersNeeded();
      if (isSyncNeeded) {
        this._syncVisitPlanAndScheduleFilters(filters);
        this.onVisitScheduleFiltersChange(this.filtersConfig.visitSchedule.bringozFilters);
      }
    }

    this._getVisitPlanAccounts();

    if (reloadVisitSchedule) {
      this._setVisitScheduleTimeline(this.visitPlan);
    }
  }

  onToggleSyncVisitPlanAndScheduleFilters() {
    this.isSyncVisitPlanAndScheduleFilters = !this.isSyncVisitPlanAndScheduleFilters;

    if (this.isSyncVisitPlanAndScheduleFilters) {
      const isSyncNeeded = this._isSyncVisitPlanAndScheduleFiltersNeeded();
      if (isSyncNeeded) {
        this._syncVisitPlanAndScheduleFilters(this.filtersConfig.visitPlan.bringozFilters);
        this._getVisitPlanAccounts();
        this.onVisitScheduleFiltersChange(this.filtersConfig.visitSchedule.bringozFilters);
      }
    }
  }

  // onVisitPlanBranchesSelect(branchIds: string[]) {
  //   if (branchIds === this.filtersConfig.visitPlan.bringozFilters.branchIds) return;
  //   this.filtersConfig.visitPlan.bringozFilters.branchIds = branchIds;
  //   this._getVisitPlanAccounts();
  // }
  //
  // onVisitPlanServiceAreasSelect(serviceAreaIds: string[]) {
  //   if (serviceAreaIds === this.filtersConfig.visitPlan.bringozFilters.serviceAreaIds) return;
  //   this.filtersConfig.visitPlan.bringozFilters.serviceAreaIds = serviceAreaIds;
  //   this._getVisitPlanAccounts();
  //
  //   if (this.filtersConfig.visitSchedule) {
  //     this.filtersConfig.visitSchedule.bringozFilters.serviceAreaIds = serviceAreaIds;
  //     this._setVisitScheduleTimeline(this.visitPlan);
  //   }
  // }

  onDatesBrowse(isNext: boolean) {
    const range = angular.copy(this.filtersConfig.visitPlan.range);

    if (isNext) {
      range.dateStart = this.moment(range.dateStart).add(1, 'day').valueOf();
      range.dateEnd = this.moment(range.dateEnd).add(1, 'day').valueOf();
    } else {
      range.dateStart = this.moment(range.dateStart).subtract(1, 'day').valueOf()
      range.dateEnd = this.moment(range.dateEnd).subtract(1, 'day').valueOf()
    }

    if (range.dateStart < this.visitPlan.from) {
      range.dateStart = angular.copy(this.visitPlan.from);
    }

    if (range.dateEnd > this.visitPlan.to) {
      range.dateEnd = angular.copy(this.visitPlan.to);
    }

    this.onVisitPlanRangeChanged(range);
  }

  isDateBrowseDisabled(date1, date2) {
    return this.moment(this.moment(date1).format("MM/DD/YYYY")).isSame(this.moment(date2).format("MM/DD/YYYY"));
  }

  onResetDateSelection() {
    const range = {dateStart: this.visitPlan.from, dateEnd: this.visitPlan.to}
    this.onVisitPlanRangeChanged(range);
  }

  onVisitPlanRangeChanged(range) {
    if (this.filtersConfig.visitPlan.range !== range) {
      this.filtersConfig.visitPlan.range = range;
      this._getVisitPlanAccounts();

      if (this.filtersConfig.visitSchedule) {
        this.filtersConfig.visitSchedule.range = range;

         const panelsCopy = this.panels.filter(panel =>
            !(
              panel.selectedPanelType === 'jobs' ||
              (panel.selectedPanelType === 'routes' && !!panel.selectedRouteId)
            )
          );

         if (this.panels?.length !== panelsCopy?.length) {
           this.panels = panelsCopy;
         }

        this._setViewData();
        this._getVisitScheduleDaysData(this.visitPlan);
      }
    }
  }

  onAddCall(cellId, date, account) {
    if (this.isActionBlocked()) return;

    this.schedulingProjectDialogService.createVisitPlanCall(this.serviceTypeOptions.Operation, date, account, this.visitPlan)
      .then((payload: {call: VisitPlanCallModel, recurrencePattern?: RecurrencePatternModel}) => {
        this.visitPlanAccountFacadeService.createCall(
          this.visitPlanId,
          cellId,
          payload.call,
          payload.recurrencePattern
        );
      })
  }

  onAdvanceEditCall(cellId, call, cell, account) {
    if (this.isActionBlocked()) return;

    const callType = this.programTypeAliasMap[getFieldValue(call.programType)];
    this.schedulingProjectDialogService.editVisitPlanCall(call, callType, this.visitPlan, account)
      .then((payload: {call, isPermanent}) => {
        const cellCopy = angular.copy(cell);
        const callIndex = cell.calls.findIndex((c) => c.id === call.id);
        cellCopy.calls.splice(callIndex, 1, payload.call);

        const callIdConfigurationUpdateOptions: Record<string, VisitPlanTrackerCallRecurringConfigurationOptionsModel> = payload.isPermanent ? {
          [call.id]: {
            skillsUpdate: true,
            programTypeUpdate: true,
            serviceTypeUpdate: true,
            originSubtasksUpdate: false,
            destinationSubtasksUpdate: true,
            timeWindowUpdate: true
          }
        } : undefined;
        this.onUpdateVisitCellTracker(cellCopy, callIdConfigurationUpdateOptions);
      })


    function getFieldValue(field: any) {
      if (!field) {
        return undefined;
      } else if (isUndefined(field.adjusted?.value)) {
        return field.initial?.value
      } else {
        return field.adjusted?.value
      }
    }
  }

  onVisitScheduleQueryChange(queryString) {
    this.filtersConfig.visitSchedule.queryString = queryString;
    this._setVisitScheduleTimeline(this.visitPlan);
  }

  onExternalFilterChange(external) {
    this.filtersConfig.visitSchedule.bringozFilters.external = external;
    this.onVisitScheduleFiltersChange(this.filtersConfig.visitSchedule.bringozFilters);
  }

  onVisitScheduleFiltersChange(filters) {
    this.filtersConfig.visitSchedule.bringozFilters = filters;

    if (this.isSyncVisitPlanAndScheduleFilters) {
      const isSyncNeeded = this._isSyncVisitPlanAndScheduleFiltersNeeded();
      if (isSyncNeeded) {
        this._syncVisitPlanAndScheduleFilters(filters);
        this.onFiltersChange(this.filtersConfig.visitPlan.bringozFilters);
      }
    }

    this._setVisitScheduleTimeline(this.visitPlan);
    // this._setStateParams();
  }

  onDeleteCalls(callIds: string[], cellId: string, $event) {
    if (this.isActionBlocked()) return;

    const text = 'Are you sure you want to delete these calls?';
    const actions = this.commonsService.getConfirmActions(['Permanent'], false);
    this.confirmDialogService.confirmWithActions('Delete Calls', text, actions, $event)
      .then((actionsResponse) => {
        const deleteRecurringConfiguration: boolean = actionsResponse[0].enabled;

        this.visitPlanAccountFacadeService.deleteCallsFromCell(this.visitPlanId, cellId, callIds, deleteRecurringConfiguration);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      });
  }

  onEditCallServiceTime(callId: string, slot: VisitPlanCellModel, isDayDispatched: boolean, event) {
    if (this.isActionBlocked()) return;

    const panel = this.panelService.open(CellEditDialogComponent, event, {
      visitPlanCell: slot,
      visitPlanCellTracker: slot.tracker?.entity,
      programTypeAliasMap: this.programTypeAliasMap,
      dateRange: {from: this.visitPlan.from, to: this.visitPlan.to},
      isDeliveryEdit: false,
      visitPlan: this.visitPlan,
      visitScheduleDays: this.visitScheduleDays,
      isDayDispatched: isDayDispatched,
      isServiceTimeFromMLPrediction: this.visitPlan['visitPlanConfig'].visitSlotProviderTypeRegistry.visitSlotServiceTimeProviderType.some((providerType) => providerType === "MDLZ_PREDICTION"),
      initialEditCallId: callId
    }, {
      height: 300
    })

    panel?.afterClose$.subscribe((data) => {
      if (!!data?.visitPlanCell) {
        this.onUpdateVisitCellTracker(data.visitPlanCell, undefined);
      }
    })
  }

  onUpdateVisitCellTracker(visitPlanCell: VisitPlanCellModel, callIdConfigurationUpdateOptions: Record<string, VisitPlanTrackerCallRecurringConfigurationOptionsModel>) {
    if (this.isActionBlocked()) return;

    this.visitPlanAccountFacadeService.updateCellTracker(this.visitPlanId, visitPlanCell, callIdConfigurationUpdateOptions);
  }

  onUpdateCallsTimeWindow(list: { callId: string, notBefore: number, notAfter: number }[], cellId: string, $event) {
    if (this.isActionBlocked()) return;

    const text = 'Are you sure you want to move day these calls?';
    this.confirmDialogService.confirm('Move Days', text, $event)
      .then(() => {
        this.visitPlanAccountFacadeService.updateCallsTimeWindow(this.visitPlanId, cellId, list);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      });
  }

  onViewTrackerChanges() {
    if (this.isActionBlocked()) return;

    this.schedulingProjectDialogService.onViewVisitPlanTrackedChanges(this.visitPlan, this.isNotSynced)
      .then((payload) => {
        if (payload.syncChanges) {
          this.onSyncVisitPlan();
          return;
        } else if (payload.action === 'save') {
          this._onSubmitVisitPlanTracker(payload.includeIds, payload.excludeIds);
        } else {
          this._discardChanges(payload.includeIds, payload.excludeIds);
        }

        // if (!!payload?.discardIds?.length) {
        //   this._discardChanges(payload.discardIds);
        // } else {
        //   this._onSubmitVisitPlanTracker(payload.payload.includeIds, payload.payload.excludeIds);
        // }
      })
  }


  onPaginationChange(page) {
    this.filtersConfig.visitSchedule.page = page - 1;
    this.hiddenRoutesAgentIds = [];
    // this._setMapRoutes();

    // this._setStateParams();
    this._setVisitScheduleTimeline(this.visitPlan);
  }

  onPageSizeChange(size) {
    this.filtersConfig.visitSchedule.size = size;
    this.filtersConfig.visitSchedule.page = 0;

    // this._setStateParams();
    this._setVisitScheduleTimeline(this.visitPlan);
  }

  onVisitScheduleToggleTimeline() {
    this.visitScheduleTimelineEnabled = !this.visitScheduleTimelineEnabled;

    if (!this.visitScheduleTimelineEnabled) {
      this.isVisitScheduleFullyExpanded = false;
    }
  }

  onVisitScheduleTimelineFullScreen() {
    this.isVisitScheduleFullyExpanded = !this.isVisitScheduleFullyExpanded;

    if (this.isVisitScheduleFullyExpanded) {
      this.visitScheduleTimelineEnabled = true;
    } else {
      const timelineElement = document.getElementById('visit-schedule-container');
      timelineElement.style.height = '270px';
    }

    // const timelineElement = document.getElementById('visit-schedule-container');
    // const height = this.isVisitScheduleFullyExpanded ? window.innerHeight : 280;
    // timelineElement.style.height = height + 'px';
  }


  onCreateRoute(
    jobIds: string[],
    resourceId: string,
    callIds?: string[],
    cellId?: string,
    accountId?: string,
    dateRange?: { from: number, to: number }
  ) {
    if (this.isActionBlocked()) return;

    // Handle case when called from cell-edit-dialog (no jobIds provided, needs refresh)
    if (!jobIds?.length && callIds?.length && cellId) {
      this.pendingAnalysisRefresh = true;
      this._getVisitPlanAccounts();
      this.$timeout(() => {
        if (this.visitPlan?.scheduleStatus === this.visitPlanScheduleStatuses.PLANNED) {
          this._getRoutes();
        }
      }, 500);

      return;
    }

    if (this.visitPlan?.hasNotSyncedChanges) {
      return;
    }

    if (!jobIds?.length) {
      return;
    }

    const routeResource = this.visitPlanRoutes.find(r => r.resource.id === resourceId);
    const allocationSkills = routeResource
      ? routeResource.resource?.allocationSkills
      : this.resources?.find(r => r.id === resourceId)?.allocationSkills;

    if (this._hasSkillMismatch(jobIds, allocationSkills)) {
      this.schedulingProjectAlertsService.noMatchingSkillsInfo();
      return;
    }

    if (this._areJobsOnDispatchedDay(jobIds)) {
      this.schedulingProjectAlertsService.createRouteDayDispatchedError();
      return;
    }

    if (routeResource) {
      if (isVisitScheduleDayDispatchedById(this.visitScheduleDays, routeResource.visitScheduleDayId)) {
        this.schedulingProjectAlertsService.createRouteDayDispatchedError();
        return;
      }

      const stopsToAdd = _.chain(this.jobs)
        .filter((j) => {
          return _.includes(jobIds, j.id);
        })
        .map('stops')
        .flatten()
        .value();

      const order = _.uniq(routeResource.stopsOrder.concat(_.map(stopsToAdd, 'id')));
      const payload = {
        jobIds: jobIds,
        toRouteId: routeResource.id,
        toOrderedIds: order
      }
      this.onMoveJobs(payload);
      return;
    }

    // Otherwise use direct API call (for jobs panel)
    this.commonsFacadeService.setLoaderOn();

    this.isReloadPanelsData = false;
    this.visitPlanScheduleFacadeService.createVisitScheduleRoute(this.visitPlanId, this.visitPlan.scheduleId, {
      jobIds,
      resourceId
    }).subscribe({
      next: (route) => {
        this.schedulingProjectAlertsService.createRouteSuccess();
        // this.routes = [...this.routes, route];
        this.visitPlanRoutes = _.uniqBy([...this.visitPlanRoutes, route], 'id');
        this.isReloadPanelsData = true;
        this.commonsFacadeService.setLoaderOff();
      },
      error: (error) => {
        if (error?.status === 412 || error?.error?.code === 412205) {
          this.schedulingProjectAlertsService.createRouteDayDispatchedError();
        } else {
          this.schedulingProjectAlertsService.createRouteError();
        }
        this.commonsFacadeService.setLoaderOff();
      },
      complete: () => {
        this.commonsFacadeService.setLoaderOff();
      }
    });
  }

  onDeleteRoutes(routeIds: string[], $event?) {
    if (this.isActionBlocked()) return;

    const header = routeIds.length > 1 ?
      'Delete Routes' :
      'Delete Route';
    const text = routeIds.length > 1 ?
      'Are you sure you want to delete these routes?' :
      'Are you sure you want to delete this route?';

    this.confirmDialogService.confirm(header, text, $event)
      .then(() => {
        this.commonsFacadeService.setLoaderOn();
        this.visitPlanScheduleFacadeService.deleteRoutes(this.visitPlanId, this.visitPlan.scheduleId, routeIds)
          .subscribe({
            next: () => {
              this.schedulingProjectAlertsService.deleteRoutesSuccess();
              this.$timeout(() => {
                if (this.visitPlan?.scheduleStatus === this.visitPlanScheduleStatuses.PLANNED) {
                  this._getRoutes();
                }
              }, 500);
            },
            error: () => {
              this.schedulingProjectAlertsService.deleteRoutesError();
            },
            complete: () => {
              this.commonsFacadeService.setLoaderOff();
            }
          });
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      });
  }


  onAddPanel(selectedPanelType, selectedRouteId) {
    const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
    const panel: any = {
      id: this.moment().valueOf().toString(),
      filtersConfig: {
        range: this.mapVisitScheduleDays?.length ? {
          dateStart: moment(this.mapVisitScheduleDays[0].date).startOf('day').valueOf(),
          dateEnd: moment(this.mapVisitScheduleDays[0].date).endOf('day').valueOf()
        } : undefined,
      },
      selectedPanelType: selectedPanelType,
      selectedRouteId: selectedRouteId
    };

    panelsCopy.push(panel);
    this.panels = panelsCopy;

    this.isVisitScheduleFullyExpanded = this.panels.some(p => p.selectedPanelType === 'jobs');
    // this.isVisitScheduleFullyExpanded = !!this.panels.length;

    if (this.isVisitScheduleFullyExpanded) {
      this.filtersConfig.visitSchedule.range = {
        dateStart: panel.range?.dateStart || this.moment(this.visitScheduleDays[0].date).startOf('day').valueOf(),
        dateEnd: panel.range?.dateEnd || this.moment(this.visitScheduleDays[0].date).endOf('day').valueOf()
      };
      this._setViewData();
      this._getVisitScheduleDaysData(this.visitPlan);
    }
    // this._setViewData();
    // this._getVisitScheduleDaysData(this.visitPlan);
  }

  onPanelChange(panel, index) {
    const panelsCopy: PlanningPanelModel[] = angular.copy(this.panels);
    panelsCopy[index] = panel;

    this.panels = panelsCopy;

    const jobsPanel = this.panels.find((p) => {
      return p.selectedPanelType === 'jobs';
    })
    if (jobsPanel && this.isMapView) {
      this._setMapJobs();
      const mapVisitScheduleDay = _.find(this.visitScheduleDays, (d) => {
        return !!this.moment(this.moment(d.date).format("MM/DD/YYYY")).isSame(this.moment(jobsPanel.filtersConfig.range.dateStart).format("MM/DD/YYYY"));
      });
      this.mapVisitScheduleDays = mapVisitScheduleDay ? [mapVisitScheduleDay] : [];
    }

  }

  onChangePanelDateRange(range) {
    if (this.isVisitScheduleFullyExpanded) {
      this.filtersConfig.visitSchedule.range = range;
      this._setViewData();
      this._getVisitScheduleDaysData(this.visitPlan);
    }
  }

  onClosePanel(index) {
    const currentlyHasJobsPanel = this.panels.some(p => p.selectedPanelType === 'jobs');
    const panelsCopy: any[] = angular.copy(this.panels);
    panelsCopy.splice(index, 1);

    this.panels = panelsCopy;

    this.isVisitScheduleFullyExpanded = this.panels.some(p => p.selectedPanelType === 'jobs');

    if (!!currentlyHasJobsPanel && !this.isVisitScheduleFullyExpanded) {
      this.onVisitPlanRangeChanged({dateStart: this.visitPlan.from, dateEnd: this.visitPlan.to});
    }

    // this.isVisitScheduleFullyExpanded = !!this.panels.length;

    // if (!this.isVisitScheduleFullyExpanded) {
    //   this.filtersConfig.visitSchedule.range = this.filtersConfig.visitPlan.range;
    //   this._setViewData();
    //   this._getVisitScheduleDaysData(this.visitPlan);
    // }
  }

  onPublishVisitSchedule($event) {
    if (this.isActionBlocked()) return;

    this._getBlockingConflictResourceHolderIds().subscribe(resourceHolderIds => {
      if (resourceHolderIds.length) {
        this.schedulingProjectDialogService.showPublishConflictsDialog($event).then((goToAvailability) => {
          if (goToAvailability) {
            this.onOpenConflictAvailability($event, true);
          }
        });
        return;
      }

      const text = 'Please note you are about to publish the planned schedules and notify all relevant employees. Would you like to proceed?';
      this.confirmDialogService.confirm('Publish', text, $event)
        .then(() => {
          this.commonsFacadeService.setLoaderOn();
          this.visitPlanScheduleFacadeService.publishVisitSchedule(this.visitPlanId, this.visitPlan.scheduleId)
            .subscribe({
              next: () => {
                this.schedulingProjectAlertsService.publishVisitScheduleSuccess();
                this.commonsFacadeService.setLoaderOff();
              },
              error: () => {
                this.schedulingProjectAlertsService.publishVisitScheduleError();
                this.commonsFacadeService.setLoaderOff();
              },
              complete: () => {
                this.commonsFacadeService.setLoaderOff();
              }
            });
        })
        .catch((error) => {
          this.$log.info('Dialog Closed', error);
        });
    });
  }

  onShowAutoDispatchPanel(event): void {
    if (this.isActionBlocked()) return;

    if (!this.visitPlan?.scheduleId || !this.visitSchedule || this.autoDispatchSaving || this.visitPlan.hasNotSyncedChanges) {
      return;
    }

    const panel = this.panelService.open(VisitPlanAutoDispatchDialogComponent, event, {
      enabled: this.autoDispatchEnabledUi,
      selectedRange: this.autoDispatchSavedRange,
      timeRanges: this.autoDispatchTimeRanges,
      saving: this.autoDispatchSaving
    }, {
      position: {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top',
      },
      width: 280
    });

    if (!panel) {
      return;
    }

    panel.afterClose$.subscribe((result) => {
      if (!result) {
        return;
      }
      this._saveAutoDispatchSettings(result.enabled, result.range);
    });
  }

  private _saveAutoDispatchSettings(enabled: boolean, range: AutoDispatchTimeRange): void {
    if (!this.visitPlan?.scheduleId || !this.visitSchedule || this.autoDispatchSaving || this.visitPlan.hasNotSyncedChanges || !range) {
      return;
    }
    const next: VisitScheduleDispatchSettingsModel = {
      autoDispatchEnabled: enabled,
      autoDispatchTimeFrom: range.from,
      autoDispatchTimeTo: range.to
    };
    const current = this.visitSchedule.visitScheduleDispatchSettings;
    if (current
      && current.autoDispatchEnabled === next.autoDispatchEnabled
      && current.autoDispatchTimeFrom === next.autoDispatchTimeFrom
      && current.autoDispatchTimeTo === next.autoDispatchTimeTo) {
      return;
    }

    const payload = _.cloneDeep(this.visitSchedule);
    payload.visitScheduleDispatchSettings = next;

    this.autoDispatchSaving = true;
    this.visitPlanHttpService.autoDispatchVisitSchedule(this.visitPlanId, this.visitPlan.scheduleId, payload)
      .pipe(finalize(() => {
        this.autoDispatchSaving = false;
        this.$timeout(() => {
        }, 0);
      }))
      .subscribe({
        next: (updated: VisitScheduleModel) => {
          this.visitScheduleFacadeService.setOne(updated, false);
          this.schedulingProjectAlertsService.updateAutoDispatchSettingsSuccess();
        },
        error: () => {
          this._syncAutoDispatchUiFromVisitSchedule();
          this.schedulingProjectAlertsService.updateAutoDispatchSettingsError();
        }
      });
  }

  private _syncAutoDispatchUiFromVisitSchedule(): void {
    if (!this.visitSchedule) {
      return;
    }
    const dispatchSettings = this.visitSchedule.visitScheduleDispatchSettings;
    this.autoDispatchEnabledUi = dispatchSettings?.autoDispatchEnabled ?? false;
    this.autoDispatchSavedRange = findAutoDispatchTimeRange(
      this.autoDispatchTimeRanges,
      dispatchSettings?.autoDispatchTimeFrom,
      dispatchSettings?.autoDispatchTimeTo
    );
  }

  onAvailability(event) {
    if (this.isActionBlocked()) return;

    this.schedulingProjectDialogService.showAvailabilityDialog(
      this.visitPlan,
      this.visitPlan.scheduleId,
      this.visitPlan.branchIds,
      this.filtersConfig.visitSchedule.range.dateStart,
      this.filtersConfig.visitSchedule.range.dateEnd,
      this.visitPlan.zoneId,
      event
    ).then((data) => {
      // Handle dialog close - merge updated resources into timeline
      // This is called regardless of how the dialog was closed (button, backdrop, ESC)
      if (data && data.success && data.resources && data.resources.length) {
        this._mergeUpdatedResources(data.resources);
        this.onManualRefreshRoutes();
      }
      if (data?.refreshSchedule) {
        this._setVisitScheduleTimeline(this.visitPlan);
      }
    });
  }

  private _mergeUpdatedResources(updatedResources: VisitScheduleResourceModel[]) {
    if (!this.resources || !updatedResources || !updatedResources.length) {
      return;
    }

    // Create a map of updated resources for faster lookup
    const updatedMap = new Map(updatedResources.map(r => [r.id, r]));

    // Update existing resources in the timeline
    this.resources = this.resources.map(r => {
      if (updatedMap.has(r.id)) {
        const updated = updatedMap.get(r.id)!;
        updatedMap.delete(r.id); // Remove from map so we know what's left
        return updated;
      }
      return r;
    });

    // Append any new resources
    if (updatedMap.size > 0) {
      this.resources = [...this.resources, ...Array.from(updatedMap.values())];
    }

    // Trigger Angular/AngularJS change detection
    this.$timeout(() => {
    }, 0);
  }

  onManualRefreshSchedule(params?: VisitScheduleRefreshParams) {
    if (this.isActionBlocked()) return;

    // Build params from component state if not provided
    const refreshParams: VisitScheduleRefreshParams = params || {
      resourceHolderIds: _.map(this.resourceHoldersPaginationData?.content, 'id'),
      from: this.filtersConfig.visitSchedule.range.dateStart,
      to: this.filtersConfig.visitSchedule.range.dateEnd,
      includeCompletedDays: false
    };

    this.bringozLoaderService.on();
    this.visitPlanHttpService.manualRefreshSchedule(this.visitPlanId, this.visitPlan.scheduleId, refreshParams).subscribe({
      next: (changes) => {
        this.schedulingProjectAlertsService.manualRefreshScheduleSuccess();

        // Refresh the resources and routes
        this._getResources(_.map(this.resourceHoldersPaginationData?.content, 'id'));
        this._getRoutes();
      },
      error: (error) => {
        this.schedulingProjectAlertsService.manualRefreshScheduleError();
      },
      complete: () => {
        this.bringozLoaderService.off();
      }
    });
  }

  onOptimizeVisitSchedule(event) {
    if (this.isActionBlocked()) return;

    const panel = this.panelService.open(OptimizationDaySelectDialogComponent, event, {
      visitDays: this.visitScheduleDays,
    }, {
      position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
      },
      height: 370
    })

    if (panel) {
      panel.afterClose$
        .subscribe((daysIds) => {
        if (!!daysIds) {
          this.onConfirmOptimizeVisitSchedule(event);
        }
      })
    }
  }

  onConfirmOptimizeVisitSchedule(event) {
    if (this.isActionBlocked()) return;

    this.confirmDialogService.confirm('Optimize Visit Schedule', 'VISIT_SCHEDULE_OPTIMIZE_CONFIRMATION', event)
      .then(() => {
        this.openOptimizeVisitScheduleDialog(event);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      });
  }

  openOptimizeVisitScheduleDialog(event) {
    if (this.isActionBlocked()) return;

    let dialogData = {
      tabs: ['visitDays', 'hardConstraints', 'softConstraints'],
      visitScheduleOptimizationSettings: {...this.visitSchedule.visitScheduleOptimizationSettings},
      visitScheduleResourceSettings: this.visitSchedule.visitScheduleResourceSettings,
      visitDays: [...this.visitScheduleDays]
    };
    this.schedulingProjectDialogService
      .createOptimizeVisitScheduleFormDialog(event, {...dialogData})
      .then((visitScheduleOptimizationSettings) => {
        if (!!visitScheduleOptimizationSettings) {
          let dayIds: string[] = visitScheduleOptimizationSettings.selectedVisitDays.map((day) => day.id);
          this._optimizeVisitSchedule({dayIds, settings: visitScheduleOptimizationSettings.visitScheduleOptimizationSettings});
        }
      });
  }

  private _optimizeVisitSchedule(data: { dayIds: string[], settings: VisitScheduleOptimizationSettings }) {
    this.commonsFacadeService.setLoaderOn();
    this.visitPlanScheduleFacadeService.optimizeVisitSchedule(this.visitPlanId, this.visitPlan.scheduleId, data.settings, data.dayIds)
      .subscribe({
        next: () => {
          this.commonsFacadeService.setLoaderOff();
          this._getJobs(this.visitPlan);
        },
        error: () => {
          this.commonsFacadeService.setLoaderOff();
        },
        complete: () => {
          this.commonsFacadeService.setLoaderOff();
        }
      });
  }

  onToggleMap(visitScheduleDay) {

    this.isMapView = true;
    this.mapVisitScheduleDays = [visitScheduleDay];
    // this.mapViewStartRange = start;
    // this.mapViewEndRange = end;
    this._setMapRoutes();

    const jobsPanel = this.panels?.find((p) => {
      return p.selectedPanelType === 'jobs';
    })
    if (jobsPanel?.selectedPanelType === 'jobs') {
      this._setMapJobs();
    }

    this.$timeout(() => {
    }, 0);
  }

  onDispatchDay(visitScheduleDay) {
    // The dispatch view performs its own route/dispatch updates - keep it out of reach for a deleted project
    if (this.isActionBlocked()) return;

    this.isDispatchView = true;
    // this.dispatchViewStartRange = start;
    // this.dispatchViewEndRange = end;

    // this.dispatchVisitScheduleDays = this.visitScheduleDays.filter((vsd: VisitScheduleDayModel) => {
    //   return vsd.date >= start && vsd.date <= end;
    // })

    this.dispatchVisitScheduleDays = [visitScheduleDay];

    this.$timeout(() => {
    }, 0);
    // this._setDispatchRoutes
  }

  onCloseMapView() {
    this.isMapView = false;
    this.mapVisitScheduleDays = undefined;

    this.$timeout(() => {
    }, 0);
  }

  onCloseDispatchView() {
    this.isDispatchView = false;
    this.dispatchVisitScheduleDays = undefined;

    // this.dispatchViewStartRange = undefined;
    // this.dispatchViewEndRange = undefined;

    this.$timeout(() => {
    }, 0);
  }

  onChangeJobsSelectedIds(selectedIds: string[]) {
    this.selectedJobIds = angular.copy(selectedIds) || [];
  }

  onHiddenRoutesAgentIdsChange(ids: string[]) {
    this.hiddenRoutesAgentIds = angular.copy(ids) || [];
  }

  onSelectedRoutesChange(selectedRouteIds) {
    this.selectedRouteIds = selectedRouteIds;
  }

  onReoptimizeAllRoutes() {
    this.onReoptimizeRoutes();
  }

  onReoptimizeRoutes(routeIds?: string[], dayIds?: string[]) {
    if (this.isActionBlocked()) return;

    const visitScheduleRouteOptimizePayload: VisitScheduleRouteOptimizeRequestModel = {
      routeIds: routeIds,
      dayIds: dayIds,
      visitScheduleOptimizationSettings: this.visitSchedule['visitScheduleOptimizationSettings'],
      branchIds: this.filtersConfig.visitSchedule.bringozFilters[SiteFiltersType.branchIds],
      agentIds: this.filtersConfig.visitSchedule.bringozFilters[SiteFiltersType.agentIds],
      from: this.filtersConfig.visitSchedule.range.dateStart,
      to: this.filtersConfig.visitSchedule.range.dateEnd,
    };
    this.visitPlanScheduleFacadeService.visitScheduleRouteOptimize(
      this.visitPlanId,
      this.visitPlan.scheduleId,
      visitScheduleRouteOptimizePayload)
      .subscribe({
        next: (updatedRoutes) => {
          this.schedulingProjectAlertsService.visitScheduleRecalcSuccess();
          this.selectedRouteIds = [];
          this.$timeout(() => {
          }, 0);
        },
        error: (res) => {
          if (res) {

            if (res.error?.code === 412205) {
              this.schedulingProjectAlertsService.reoptimizeRoutesWhenDispatchedError();
            }

          }
        }
      });
  }

  onMoveToLeftovers(payload: {
    id: string, // Route ID
    remove: string}[] // Job IDs
  ) {
    if (this.isActionBlocked()) return;

    if (this.visitPlan?.hasNotSyncedChanges) {
      return;
    }

    if (payload?.some(item => this._isRouteDayDispatched(item.id))) {
      this.schedulingProjectAlertsService.moveToLeftoversDayDispatchedError();
      return;
    }

    this.visitPlanHttpService
      .editRoute(this.visitPlan.id, this.visitPlan.scheduleId, payload, { group: true })
      .subscribe({
        next: (updatedRoutes) => {
          this.visitPlanRoutes = _.unionBy(updatedRoutes, this.visitPlanRoutes, 'id');
          this.isReloadPanelsData = true;
          this._syncVisitPlanAccountAnalysis();
          // this._getVisitPlanAccounts();

          if (this.isMapView) {
            this._setMapRoutes();
          }

          this.$timeout(() => {
          }, 0);
        },
        error: (res) => {
          if (res) {
            if (res.error?.code === 412205) {
              this.schedulingProjectAlertsService.moveToLeftoversDayDispatchedError();
            }
          }
        }

      });
  }

  onMoveJobs(payload, rollbackData?: {fromRouteId: string; toRouteId?: string; prevListSnapshot: any[]; currListSnapshot: any[]}) {
    if (this.isActionBlocked()) return;

    const requestPayload = this.TimelineService.getMovedTaskPayload(payload.jobIds, payload.fromRouteId, payload.toRouteId, payload.fromOrderedIds, payload.toOrderedIds);

    this.isReloadPanelsData = false;

    this.visitPlanHttpService
      .editRoute(this.visitPlan.id, this.visitPlan.scheduleId, requestPayload, { group: true })
      .subscribe({
        next: (updatedRoutes) => {
          this.visitPlanRoutes = _.unionBy(updatedRoutes, this.visitPlanRoutes, 'id');
          this.isReloadPanelsData = true;
          this._syncVisitPlanAccountAnalysis();
          // this._getVisitPlanAccounts();

          if (!payload.toRouteId && !!payload.scheduleInstanceId) {
            this.onCreateRoute(payload.jobIds, payload.scheduleInstanceId);
          }

          if (this.visitPlan.resourcesImportCompleted && this.visitPlan.slotsImportCompleted) {
            this._getResourcesUtilization();
          }

          this._getVisitScheduleRisks();

          if (this.isMapView) {
            this._setMapRoutes();
          }

          this.$timeout(() => {
          }, 0);
        },
        error: (res) => {
          if (res) {

            if (res.error?.code === 412205) {
              this.schedulingProjectAlertsService.moveJobsDayDispatchedError();
            } else if (res.error?.code === 400448) {
              this.schedulingProjectAlertsService.resourceIsPublishedInAnotherPlan();
            } else {
              this.schedulingProjectAlertsService.onError(res.error);
            }

            if (rollbackData) {
              const fromRoute = _.find(this.visitPlanRoutes, (r) => {
                return r.id === rollbackData?.fromRouteId;
              })
              const toRoute = _.find(this.visitPlanRoutes, (r) => {
                return r.id === rollbackData?.toRouteId;
              })

              const routesCopy = angular.copy(this.visitPlanRoutes);

              if (!!fromRoute) {
                fromRoute.activities = [...rollbackData.prevListSnapshot];

                const index = routesCopy.findIndex((r) => {
                  return r.id === fromRoute.id;
                })
                routesCopy[index] = fromRoute;
              }
              if (!!toRoute) {
                toRoute.activities = [...rollbackData.currListSnapshot];

                const index = routesCopy.findIndex((r) => {
                  return r.id === toRoute.id;
                })
                routesCopy[index] = toRoute;
              }

              this.visitPlanRoutes = routesCopy;

            }
          }
        }
      });



    // this.visitPlanHttpService.editRoute(this.visitPlan.id, this.visitPlan.scheduleId, requestPayload, {group: true})
    //   .subscribe((updatedRoutes) => {
    //   this.visitPlanRoutes = _.unionBy(updatedRoutes, this.visitPlanRoutes, 'id');
    //   this.isReloadPanelsData = true;
    //   this._getVisitPlanAccounts();
    //   if (!payload.toRouteId && !!payload.scheduleInstanceId) {
    //     this.onCreateRoute(payload.jobIds, payload.scheduleInstanceId);
    //   }
    //   this.$timeout(() => {
    //   }, 0);
    // })
  }

  onRoutePanelContextMenu(routeId: string, event: any) {
    // The context menu only offers a mutating action (Reassign Route)
    if (this.isActionBlocked()) return;

    const route = this.visitPlanRoutes.find(route => route.id === routeId);
    const panel = this.panelService.open(VisitPlanRoutesPanelContextMenuComponent, event,
      {
        isRouteDispatched: isVisitPlanRouteBlocked(route, this.visitScheduleDays),
        hasNotSyncedChanges: this.visitPlan?.hasNotSyncedChanges
      },
      {
        position: {
          originX: 'center',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'top',
        },
        height: 40,
        width: 130
      }
    )

    if(panel) {
      this._routePanelContextMenuSubscription?.unsubscribe();
      this._routePanelContextMenuSubscription = panel.instance.onActionSelected
        .subscribe((selectedAction: string) => {
          if(selectedAction === 'REASSIGN_ROUTE') {
            this._openReassignRoutePanel(routeId, event);
          }
        })
    }
  }

  onToggleVisitPlanSortDialog(event) {
    const panel = this.panelService.open(VisitPlanAccountSortingDialogComponent, event, {
      sortBy: this.accountSortBy,
      sortByType: this.accountSortByType,
    }, {
      position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
      }
    })

    if (panel) {
      panel.instance.onSortTypeChange.subscribe(data => {
        this.accountSortBy = data.sortBy;
        this.accountSortByType = data.sortByType;
        this._getVisitPlanAccounts();
      });
    }
  }

  onJobRightClick(jobIds, routeId, event) {
    if (this.isActionBlocked()) return;

    if (this._isRouteDayDispatched(routeId)) {
      this.schedulingProjectAlertsService.moveJobsDayDispatchedError();
      return;
    }

    // Need to move to constants + need to add permissions
    const actions = [
      {
        key: 'REASSIGN',
        name: 'Reassign',
        icon: 'allocation'
      },
      {
        key: 'MOVE_TO_LEFTOVERS',
        name: 'Move To Leftovers',
        icon: 'trash'
      },
    ];

    const route = this.visitPlanRoutes.find((r) => {
      return r.id === routeId;
    })

    if (!isVisitPlanRouteDispatched(route)) {
      actions.push(
        {
          key: 'DELETE_ROUTE',
          name: 'Delete Route',
          icon: 'trash'
        },
        {
          key: 'REASSIGN_ROUTE',
          name: 'Reassign Route',
          icon: 'allocation'
        }
      )
    }

    this.commonsService.openActionPanel(actions, event)
      .then((reason: any) => {
        if (reason.key === 'REASSIGN') {
          this._openReassignPanel(jobIds, routeId, event);
        } else if (reason.key === 'MOVE_TO_LEFTOVERS') {
          this.onMoveJobs({
            jobIds,
            fromRouteId: routeId
          });
        } else if (reason.key === 'DELETE_ROUTE') {
          this.onDeleteRoutes([routeId]);
        } else if (reason.key === 'REASSIGN_ROUTE') {
          this._openReassignRoutePanel(routeId, event);
        }
      })
  }

  private _openReassignPanel(jobIds: string[], fromRouteId: string, event: MouseEvent) {
    // Reached from a context menu selection, so the project may have been deleted in the meantime
    if (this.isActionBlocked() || this.visitPlan?.hasNotSyncedChanges) {
      return;
    }

    const selectedJobs = this.jobs.filter(j => _.includes(jobIds, j.id));
    // Get the job to determine its specific day
    const job = selectedJobs[0];
    let dateRange = undefined;

    if (jobIds.length === 1) {

      // Use the job's day for filtering resources (not the entire filter range)
      // This ensures we only show agents available on the same day as the job
      const jobDayStart = job?.notBefore ? this.moment(job.notBefore).startOf('day').valueOf() : this.filtersConfig.visitSchedule?.range?.dateStart;
      const jobDayEnd = job?.notBefore ? this.moment(job.notBefore).endOf('day').valueOf() : this.filtersConfig.visitSchedule?.range?.dateEnd;

      dateRange = {
        from: jobDayStart,
          to: jobDayEnd
      };
    }

    const panel = this.panelService.open(VisitPlanScheduleResourceSelectListComponent, event, {
      visitPlan: this.visitPlan,
      visitScheduleId: this.visitPlan.scheduleId,
      programTypeAliasMap: this.programTypeAliasMap,
      dateRange,
      jobs: selectedJobs,
      jobIds: jobIds,
      selectJobsMode: jobIds.length > 1,
    }, {
      width: 600,
      height: 370
    });

    if (panel) {
      panel.afterClose$.subscribe((data) => {

        if (data?.refreshSchedule) {
          this._setVisitScheduleTimeline(this.visitPlan);
        }

        if (data?.selectedResourceId) {
          const targetResourceId = data.selectedResourceId;
          const targetRoute = this.visitPlanRoutes.find(r => r.resource?.id === targetResourceId);

          const targetDayId = targetRoute ? targetRoute.visitScheduleDayId : job?.visitScheduleDayId;
          const allocationSkills = targetRoute
            ? targetRoute.resource?.allocationSkills
            : this.resources?.find(r => r.id === targetResourceId)?.allocationSkills;

          if (this._hasSkillMismatch(jobIds, allocationSkills)) {
            this.schedulingProjectAlertsService.noMatchingSkillsInfo();
            return;
          }

          if (isVisitScheduleDayDispatchedById(this.visitScheduleDays, targetDayId)) {
            this.schedulingProjectAlertsService.reassignCallDayDispatchedError();
            return;
          }

          if (targetRoute) {
            // Target resource already has a route - move jobs directly
            const stopsToAdd = _.chain(this.jobs)
              .filter((j) => _.includes(jobIds, j.id))
              .map('stops')
              .flatten()
              .value();

            const toOrderedIds = _.uniq(targetRoute.stopsOrder.concat(_.map(stopsToAdd, 'id')));

            this.onMoveJobs({
              jobIds,
              fromRouteId,
              toRouteId: targetRoute.id,
              toOrderedIds
            });
          } else {
            // Create new route for target resource
            this.onMoveJobs({
              jobIds,
              fromRouteId,
              scheduleInstanceId: targetResourceId
            });
          }
        }
      });
    }
  }

  onFilterViewByVisitScheduleDay(visitScheduleDay: VisitScheduleDayModel) {

    const range = {
      dateStart: this.moment(visitScheduleDay.date).startOf('day').valueOf(),
      dateEnd: this.moment(visitScheduleDay.date).endOf('day').valueOf()
    };
    this.filtersConfig.visitPlan.range = range;
    this._getVisitPlanAccounts();

    if (this.filtersConfig.visitSchedule) {
      this.filtersConfig.visitSchedule.range = range;
      this._setViewData();
      this._getVisitScheduleDaysData(this.visitPlan);
    }
  }

  syncVisitPlanDeliveryDetails() {
    if (this.isActionBlocked()) return;

    // Success and auto recalc are handled once the processing dialog (opened by the visit plan subscription) closes
    this._isDeliveryDetailsSyncRequested = true;

    this.visitPlanFacadeService.syncVisitPlanDeliveryDetails(this.visitPlanId).subscribe({
      error: () => {
        this._isDeliveryDetailsSyncRequested = false;
        this.schedulingProjectAlertsService.updateDeliveryDataError();
      }
    });
  }

  private _handleProcessingDialogCancel(result: VisitPlanProcessingDialogResultModel): boolean {
    if (result?.recoveryAction !== RecoveryActionEnum.CANCEL) {
      return false;
    }

    this.onBackToProjects();
    return true;
  }

  private _maybeAutoRecalcAfterPullingActualData() {
    if (this.visitPlan?.status === this.visitPlanStatuses.Ongoing && !this.visitPlan.hasNotSyncedChanges
      && this.visitPlan.visitPlanConfig?.autoTriggerRecalcAfterPullingActualData) {
      this.onFetchVisitPlan();
    }
  }

  onExportVisitPlanCalls() {
    const siteId = this.splitService.getSiteId();

    this.bringozLoaderService.on();
    this.visitPlanHttpService.exportVisitPlanCalls(this.visitPlanId, this.visitPlan.scheduleId, siteId)
      .subscribe({
        next: () => {
          this.commonsAlertsService.exportToMailSuccess();
        },
        error: (error) => {
          this.commonsAlertsService.exportToMailError();
          this.$log.error('Failed to export visit plan calls', error);
        },
        complete: () => {
          this.bringozLoaderService.off();
        }
      });
  }


  onFetchVisitPlan() {
    if (this.isActionBlocked()) return;

    this.schedulingProjectAlertsService.syncVisitPlan();
    this.visitPlanAccountFacadeService.syncVisitPlan(this.visitPlanId, []);
  }

  onToggleColumnsFiltersDialog(event) {
    const filterColumnOptions =
      [
        {label: 'Delivery', field: 'isDisplayDeliveryEtd', isActive: this.tableFilterColumns.isDisplayDeliveryEtd},
        {
          label: 'Delivery Units',
          field: 'isDisplayDeliveryUnits',
          isActive: this.tableFilterColumns.isDisplayDeliveryUnits
        },
        {label: 'Call Types', field: 'isDisplayCallTypes', isActive: this.tableFilterColumns.isDisplayCallTypes},
        {label: 'Service Time', field: 'isDisplayServiceTime', isActive: this.tableFilterColumns.isDisplayServiceTime},
        {label: 'Deliveries', field: 'isDisplayDeliveryDays', isActive: this.tableFilterColumns.isDisplayDeliveryDays}
      ]
    const panel = this.panelService.open(VisitPlanTableColumnFilterDialogComponent, event, {
      filters: filterColumnOptions
    }, {
      // position: {
      //   originX: 'start',
      //   originY: 'top',
      //   overlayX: 'start',
      //   overlayY: 'top',
      // },
      height: 115,
      width: 130
    })

    panel.instance.onFilterSwitched.subscribe((columnFilter) => {
      this.tableFilterColumns = {
        ...this.tableFilterColumns,
        [columnFilter.field]: columnFilter.isActive
      };
    })

    panel.afterClose$.subscribe((result) => {
      if (!!result) {
        this.schedulingProjectAlertsService.syncVisitPlan();
        this.visitPlanAccountFacadeService.syncVisitPlan(this.visitPlanId, []);
      }
    })
  }

  onExportAgentsSummary() {
    const siteId = this.splitService.getSiteId();

    this.bringozLoaderService.on();
    this.visitPlanHttpService.exportAgentsSummary(this.visitPlanId, this.visitPlan.scheduleId, siteId)
      .subscribe({
        next: () => {
          this.commonsAlertsService.exportToMailSuccess();
        },
        error: (error) => {
          this.commonsAlertsService.exportToMailError();
          this.$log.error('Failed to export agents summary', error);
        },
        complete: () => {
          this.bringozLoaderService.off();
        }
      });
  }

  onImportVisitScheduleAgents(event: Event) {
    if (this.isActionBlocked()) return;
    if (!this.visitPlan?.scheduleId) return;

    this.schedulingProjectDialogService.importVisitScheduleAgents(
      this.visitPlanId,
      this.visitPlan.scheduleId,
      this.visitSchedule?.status,
      event
    )
      .then((result: {imported?: boolean}) => {
        if (result?.imported) {
          this._setVisitScheduleTimeline(this.visitPlan);
        }
      })
      .catch(() => {});
  }

  onExportVisitSchedule() {
    const siteId = this.splitService.getSiteId();

    this.bringozLoaderService.on();
    this.visitPlanHttpService.exportVisitSchedule(this.visitPlanId, this.visitPlan.scheduleId, siteId)
      .pipe(finalize(() => {
        this.bringozLoaderService.off();
      }))
      .subscribe({
        next: () => {
          this.commonsAlertsService.exportToMailSuccess();
        },
        error: (error) => {
          this.commonsAlertsService.exportToMailError();
          this.$log.error('Failed to export visit schedule', error);
        }
      });
  }

  onMoveToDispatchDayView() {
    // The dispatch view performs its own route/dispatch updates - keep it out of reach for a deleted project
    if (this.isActionBlocked()) return;

    const visitScheduleDay = this.visitScheduleDays?.find((d) => {
      return !d?.totals.dispatched;
    }) || this.visitScheduleDays[0];

    if (!!visitScheduleDay) {
      this.onDispatchDay(visitScheduleDay);
    }
  }

  onManualRefreshRoutes() {
    this.schedulingProjectAlertsService.refreshRoutesSuccess();
    this._getRoutes();
  }

  onOpenAuditLog(event: any) {
    this.panelService.open(VisitPlanAuditLogComponent, event, {
      visitPlan: this.visitPlan
    }, {
      hasBackdrop: true,
      height: '90vh',
      width: '95vw',
      position: {
        originX: 'center',
        originY: 'center',
        overlayX: 'center',
        overlayY: 'center',
      }
    });
  }

  onRemoveDeliveries(params: {
    accountId?: string,
    accountName?: string,
    deliveriesCount?: number,
    from?: number,
    to?: number
  }, $event?: any) {
    if (this.isActionBlocked()) return;

    if (params.accountId) {
      const week = this.$filter('bringozDateRange')({from: params.from, to: params.to}, true);

      const header = this.$filter('translate')('Delete All Deliveries');
      const text = this.$filter('translate')('DELETE_ALL_DELIVERIES_BY_ACCOUNT', {
        account: params.accountName,
        deliveries: params.deliveriesCount,
        week: week
      });

      this.confirmDialogService.confirm(header, text, $event)
        .then(() => {
          this._executeRemoveDeliveries(params);
        })
        .catch((error) => {
          this.$log.info('Remove deliveries dialog closed/cancelled', error);
        });

      return;
    }

    if (params.from !== undefined) {
      const dayName = this.$filter('bringozDay')({date: params.from}, 'date', 'long', this.timezone);
      const dayDate = this.$filter('bringozDate')({date: params.from}, 'date', false, this.timezone);
      const formattedDay = `${dayName} ${dayDate}`;

      const dayTotals = this.visitPlanDayTotals?.find(item => {
        const itemTimestamp = Number(item.date);
        return itemTimestamp >= params.from && itemTimestamp <= params.to;
      });
      const deliveriesCount = dayTotals ? dayTotals.deliveryDays : 0;

      const header = this.$filter('translate')('Delete All Deliveries');
      const text = this.$filter('translate')('DELETE_ALL_DELIVERIES_BY_DAY', { day: formattedDay, deliveries: deliveriesCount });

      this.confirmDialogService.confirm(header, text, $event)
        .then(() => {
          this._executeRemoveDeliveries(params);
        })
        .catch((error) => {
          this.$log.info('Remove deliveries dialog closed/cancelled', error);
        });
    } else {
      this._executeRemoveDeliveries(params);
    }
  }

  private _executeRemoveDeliveries(params: {accountId?: string, from?: number, to?: number}) {
    this.bringozLoaderService.on();

    const payload: {
      accountIds?: string[];
      from?: number;
      to?: number;
      projectBranchIds?: string[];
      areaIds?: string[];
      segments?: number[];
    } = {};

    if (params.accountId) {
      payload.accountIds = [params.accountId];
    }

    if (params.from !== undefined) {
      payload.from = params.from;
    }

    if (params.to !== undefined) {
      payload.to = params.to;
    }

    if (this.filtersConfig.visitPlan.bringozFilters.branchIds?.length) {
      payload.projectBranchIds = this.filtersConfig.visitPlan.bringozFilters.branchIds;
    }

    if (this.filtersConfig.visitPlan.bringozFilters.serviceAreaIds?.length) {
      payload.areaIds = this.filtersConfig.visitPlan.bringozFilters.serviceAreaIds;
    }

    const segments = this._getSegmentsFilterValue();
    if (segments) {
      payload.segments = segments;
    }

    this.visitPlanHttpService.removeDeliveries(this.visitPlanId, payload)
      .pipe(finalize(() => {
        this.bringozLoaderService.off();
      }))
      .subscribe({
        next: () => {
          this.schedulingProjectAlertsService.removeDeliveriesSuccess();
          this._getVisitPlanAccountTotalsWithoutFilters();
        },
        error: (error) => {
          this.schedulingProjectAlertsService.removeDeliveriesError();
          this.$log.error('Failed to remove deliveries', error);
        }
      });
  }

  onOpenAccountInfo(account: VisitPlanAccountModel) {
    const hasPermission = this.IAMPermissions.hasPermission('accounts.preferreddedicated.list');
    const size = 5;
    const requests: any[] = [
      firstValueFrom(this.accountsHttpService.getOne(account.accountReference.id)),
    ];

    if (hasPermission) {
      requests.push(
        this.accountsService.getPreferredAgents(account.accountReference.id, { size }),
        this.accountsService.getDedicatedAgents(account.accountReference.id, { size }),
        this.accountsService.getRestrictedAgents(account.accountReference.id, { size })
      );
    }

    Promise.all(requests)
    .then(([fullAccount, preferredAgents, dedicatedAgents, restrictedAgents]) => {
      this.schedulingProjectDialogService.openAccountInfoDialog(
        fullAccount,
        {agents: preferredAgents.content, shouldRedirectToRanking: preferredAgents.totalPages > 1},
        {agents: dedicatedAgents.content, shouldRedirectToRanking: dedicatedAgents.totalPages > 1},
        {agents: restrictedAgents.content, shouldRedirectToRanking: restrictedAgents.totalPages > 1}
      ).then((result) => {
      }).catch(() => {});
    })
    .catch((error) => {
      this.bringozToastService.error({body: 'SOMETHING_WENT_WRONG'})
    })
  }

  onLockAccountChange(accountId: string, locked: boolean) {
    if (this.isActionBlocked()) return;

    const siteId = this.splitService.getSiteId();

    this.bringozLoaderService.on();
    this.visitPlanHttpService.lockAccounts(
      this.visitPlanId,
      this.visitPlan.scheduleId,
      siteId,
      locked,
      [accountId]
    ).subscribe({
      next: (response) => {
        // Update the account's locked state in the local array
        const accountIndex = this.accounts.findIndex(a => a.id === accountId);
        if (accountIndex !== -1) {
          this.accounts[accountIndex].locked = locked;
          // Also update the locked state of all calls within this account
          for (const slot of this.accounts[accountIndex].visitSlots) {
            if (slot.calls) {
              for (const call of slot.calls) {
                call.locked = locked;
              }
            }
          }
          this.accounts = [...this.accounts];
        }

        if (locked) {
          this.schedulingProjectAlertsService.lockAccountSuccess();
        } else {
          this.schedulingProjectAlertsService.unlockAccountSuccess();
        }

        this.bringozLoaderService.off();
        this.$timeout(() => {}, 0);
      },
      error: (error) => {
        this.$log.error('Failed to update account lock state', error);
        if (locked) {
          this.schedulingProjectAlertsService.lockAccountError();
        } else {
          this.schedulingProjectAlertsService.unlockAccountError();
        }
        this.bringozLoaderService.off();
        this.$timeout(() => {}, 0);
      }
    });
  }

  onLockJob(jobId: string, locked: boolean) {
    if (this.isActionBlocked()) return;

    const siteId = this.splitService.getSiteId();

    this.bringozLoaderService.on();
    this.visitPlanHttpService.lockJobs(
      this.visitPlanId,
      this.visitPlan.scheduleId,
      siteId,
      locked,
      [jobId]
    ).subscribe({
      next: (response) => {
        if (locked) {
          this.schedulingProjectAlertsService.lockJobSuccess();
        } else {
          this.schedulingProjectAlertsService.unlockJobSuccess();
        }

        this.isReloadPanelsData = !this.isReloadPanelsData;
        this.bringozLoaderService.off();
        this.$timeout(() => {}, 0);
      },
      error: (error) => {
        this.$log.error('Failed to update job lock state', error);
        if (locked) {
          this.schedulingProjectAlertsService.lockJobError();
        } else {
          this.schedulingProjectAlertsService.unlockJobError();
        }
        this.bringozLoaderService.off();
        this.$timeout(() => {}, 0);
      }
    });
  }

  onLockRoute(routeId: string, locked: boolean) {
    if (this.isActionBlocked()) return;

    const siteId = this.splitService.getSiteId();

    this.visitPlanHttpService.lockRoutes(
      this.visitPlan.id,
      this.visitPlan.scheduleId,
      siteId,
      locked,
      [routeId]
    ).subscribe({
      next: (response) => {
        // Update the route's locked state in the local array
        const routeIndex = this.visitPlanRoutes.findIndex(r => r.id === routeId);
        if (routeIndex !== -1) {
          const routesCopy = angular.copy(this.visitPlanRoutes);
          routesCopy[routeIndex].locked = locked;

          this.visitPlanRoutes = routesCopy;
        }

        if (locked) {
          this.schedulingProjectAlertsService.lockRouteSuccess();
        } else {
          this.schedulingProjectAlertsService.unlockRouteSuccess();
        }
      },
      error: (error) => {
        console.error('Failed to update route lock state', error);
        if (locked) {
          this.schedulingProjectAlertsService.lockRouteError();
        } else {
          this.schedulingProjectAlertsService.unlockRouteError();
        }
      }
    });
  }


  onLockCallChange(callId: string, locked: boolean) {
    if (this.isActionBlocked()) return;

    const siteId = this.splitService.getSiteId();

    this.bringozLoaderService.on();
    this.visitPlanHttpService.lockCalls(
      this.visitPlanId,
      this.visitPlan.scheduleId,
      siteId,
      locked,
      [callId]
    ).subscribe({
      next: (response) => {
        // Update the call's locked state in the accounts array
        for (const account of this.accounts) {
          for (const slot of account.visitSlots) {
            const call = slot.calls?.find(c => c.id === callId);
            if (call) {
              call.locked = locked;
              break;
            }
          }
        }
        this.accounts = [...this.accounts];

        if (locked) {
          this.schedulingProjectAlertsService.lockCallSuccess();
        } else {
          this.schedulingProjectAlertsService.unlockCallSuccess();
        }

        this.bringozLoaderService.off();
        this.$timeout(() => {}, 0);
      },
      error: (error) => {
        this.$log.error('Failed to update call lock state', error);
        if (locked) {
          this.schedulingProjectAlertsService.lockCallError();
        } else {
          this.schedulingProjectAlertsService.unlockCallError();
        }
        this.bringozLoaderService.off();
        this.$timeout(() => {}, 0);
      }
    });
  }

  onRemoveCalls(from: number, to: number) {
    if (this.isActionBlocked()) return;

    const day = this.visitPlanDayTotals.find(item => {
      const itemTimestamp = Number(item.date);

      return itemTimestamp >= from && itemTimestamp <= to;
    });

    if (!day) {
      return;
    }

    this.confirmDialogService.confirmWithInfo('DELETE_ALL_CALLS_BY_DAY_TITLE', 'DELETE_ALL_CALLS_BY_DAY_DESCRIPTION', '', { calls: day.totalCalls, day: this.$filter('bringozDate')({date: day.date}, 'date') }).then(() => {
      const payload: {
        accountIds?: string[];
        from?: number;
        to?: number;
        projectBranchIds?: string[];
        areaIds?: string[];
        segments?: number[];
      } = { from, to };

      if (this.filtersConfig.visitPlan.bringozFilters.branchIds?.length) {
        payload.projectBranchIds = this.filtersConfig.visitPlan.bringozFilters.branchIds;
      }

      if (this.filtersConfig.visitPlan.bringozFilters.serviceAreaIds?.length) {
        payload.areaIds = this.filtersConfig.visitPlan.bringozFilters.serviceAreaIds;
      }

      const segments = this._getSegmentsFilterValue();
      if (segments) {
        payload.segments = segments;
      }

      this.bringozLoaderService.on();
      this.visitPlanHttpService.removeCalls(this.visitPlanId, payload)
        .pipe(finalize(() => {
          this.bringozLoaderService.off();
        }))
        .subscribe({
          next: () => {
            this.schedulingProjectAlertsService.deleteCallsSuccess();
            this._getVisitPlanAccountTotalsWithoutFilters();
          },
          error: (error) => {
            this.schedulingProjectAlertsService.deleteCallsError();
            this.$log.error('Failed to delete calls', error);
          }
        });
    });
  }

  onInspectRouteClick(routeId: string) {
    const panelIndex = this.panels.findIndex((p) => {
      return p.selectedPanelType === 'routes';
    })

    if (panelIndex === -1) {
      this.onAddPanel('routes', routeId)
    } else {
      const panelsCopy = angular.copy(this.panels);
      panelsCopy[panelIndex].selectedRouteId = routeId;

      this.panels = panelsCopy;


      // this.panels[panelIndex].selectedRouteId = routeId;
    }
  }

  onImportDeliveryDays() {
    if (this.isActionBlocked()) return;

    this.schedulingProjectDialogService.importDeliveryDays(this.visitPlanId, this.totalDeliveryDays, this.totalVisits);
  }

  // **************************
  //      Private methods
  // **************************


  // private _syncVisitSchedule() {
  //   this.visitScheduleFacadeService.syncVisitSchedule(this.visitPlanId, this.visitPlan.scheduleId)
  //     .subscribe((days: VisitScheduleDayModel[]) => {
  //       this.visitScheduleDays = days;
  //
  //       this._setPublishState();
  //
  //       this.$timeout(() => {
  //       }, 0);
  //     });
  // }

  private _setPublishState() {
    const hasRoutesVisitScheduleDays = this.visitScheduleDays.filter(vsd => vsd.totals.totalRoutes > 0);
    this.isPublished = !!hasRoutesVisitScheduleDays.length && hasRoutesVisitScheduleDays.every(vsd => vsd.totals.published);
  }

  private initAgentColorMap() {
    this.agentColorMap = {}
    this.resourceHoldersPaginationData?.content.forEach((r) => {
      this.agentColorMap[r.holderId] = this.commonsService.getColorById(r.holderId, this.colorPallet);
    })
  }


  private _setMapRoutes() {

    if (!this.mapVisitScheduleDays?.length) return;
    const displayedAgentsIds = _.map(this.resourceHoldersPaginationData?.content, 'holderId');

    this.mapRoutes = this.visitPlanRoutes.filter(route => {

      const isDisplayedAgent = displayedAgentsIds.includes(route.resource.agentId);
      // const routeStart = route.activities[0].eta;
      // const routeEnd = route.activities[route.activities.length - 1].etd;

      return this.mapVisitScheduleDays.map(vsd => vsd.id).includes(route.visitScheduleDayId) && isDisplayedAgent;
    });
  }

  private _setMapJobs() {
    this.visitPlanScheduleFacadeService.clearStore();
    this.visitPlanScheduleFacadeService.getManyJobs(this.visitPlan.id, this.visitPlan.scheduleId, this._getJobsQueryParams());
  }

  private _getJobsQueryParams() {
    const jobsPanel = this.panels?.find((p) => {
      return p.selectedPanelType === 'jobs';
    })
    const filtersConfig = jobsPanel?.filtersConfig;
    const params = {
      limit: 1000,
      routed: filtersConfig.bringozFilters[SiteFiltersType.inRoute],
      accountIds: filtersConfig.bringozFilters[SiteFiltersType.accountIds],
      projectBranchIds: filtersConfig.bringozFilters[SiteFiltersType.branchIds],
      from: filtersConfig.range.dateStart,
      to: filtersConfig.range.dateEnd,
      query: filtersConfig.queryString,
    }
    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
    return params;
  }


  private _discardChanges(includeIds?: string[], excludeIds?: string[]) {
    this.schedulingProjectAlertsService.discardCellTrackersSuccess();
    this.visitPlanAccountFacadeService.discardChanges(this.visitPlanId, includeIds, excludeIds);
  }

  private _onSubmitVisitPlanTracker(includeIds?: string[], excludeIds?: string[]) {
    this.schedulingProjectAlertsService.submitCellTrackersSuccess();
    this.visitPlanAccountFacadeService.submitVisitPlanTracker(this.visitPlanId, includeIds, excludeIds);
  }

  private _getVisitPlanAccounts() {
    if (this.isLoadingAccounts) return;
    console.count('_getVisitPlanAccounts called');

    this.visitPlanAccountFacadeService.clearStore();

    const params = this._getQueryWithLimitPayload();
    this.visitPlanAccountFacadeService.getMany(this.visitPlanId, params);
    this._getVisitPlanAccountTotals(params); // Get filtered totals for table footer
  }


  private _getVisitPlanAccountTotals(params) {
    this.visitPlanDayTotals = undefined;
    const paramCopy = {
      ...params,
      groupByDate: true
    }
    console.count('_getVisitPlanAccountTotals called');

    this.visitPlanAccountFacadeService.getVisitPlanAccountTotals(this.visitPlanId, paramCopy)
      .subscribe(visitPlanDayTotals => {
        this.visitPlanDayTotals = visitPlanDayTotals; // Update table footer totals
        // Don't call _calculateTotals() here as it uses overall totals
        this.$timeout(() => {

        }, 0);
      });


    const initialParamsCopy = {
      ...paramCopy,
      initialTotals: true
    }
    this.visitPlanAccountFacadeService.getVisitPlanAccountTotals(this.visitPlanId, initialParamsCopy)
      .subscribe(visitPlanInitialDayTotals => {
        this.visitPlanInitialDayTotals = visitPlanInitialDayTotals;
        this.$timeout(() => {

        }, 0);
      });
  }

  private _getVisitPlanAccountTotalsWithoutFilters() {
    const params = {
      groupByDate: true
    }
    console.count('_getVisitPlanAccountTotalsWithoutFilters called');

    if (this.visitPlanAccountTotalsSubscription) {
      this.visitPlanAccountTotalsSubscription.unsubscribe();
    }
    this.visitPlanAccountTotalsSubscription = this.visitPlanAccountFacadeService.getVisitPlanAccountTotals(this.visitPlanId, params)
      .subscribe(visitPlanDayTotals => {
        this.overallDayTotals = visitPlanDayTotals; // Store overall totals separately
        if (!this.visitPlanDayTotals) {
          this.visitPlanDayTotals = visitPlanDayTotals; // Initialize table totals if not set
        }
        this._calculateTotals(true);
        this.$timeout(() => {}, 0);
      });
  }

  private _calculateTotals(getCphSummary?: boolean) {
    if (!this.overallDayTotals || this.overallDayTotals.length === 0) {
      this.totalDeliveryDays = 0;
      this.totalUnits = 0;
      this.totalVisits = 0;
      this.totalCPH = 0;
      this.mainCph = undefined;
      this.targetCPH = undefined;
      this.totalServiceTime = 0;
      this.totalServiceTimeFormatted = '';
      return;
    }

    this.totalDeliveryDays = this.overallDayTotals.reduce((sum, day) => sum + (day.deliveryDays || 0), 0);
    this.totalUnits = this.overallDayTotals.reduce((sum, day) => sum + (day.deliveryUnits || 0), 0);
    this.totalVisits = this.overallDayTotals.reduce((sum, day) => sum + (day.totalCalls || 0), 0);
    this.totalServiceTime = this.overallDayTotals.reduce((sum, day) => sum + (day.destinationServiceTime || 0), 0);
    const totalSeconds = Math.floor(this.totalServiceTime / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    this.totalServiceTimeFormatted = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    this.totalCPH = this.visitSchedule && this.visitSchedule['totals'].totalRoutesDurationSec
      ? Number((this.totalUnits / (this.visitSchedule['totals'].totalRoutesDurationSec / (60 * 60))).toFixed(2))
      : 0;

    this.targetCPH = this.visitPlan.cphTargets?.length
      ? Number(Math.min(...this.visitPlan.cphTargets.map(cphTarget => cphTarget.target)).toFixed(2))
      : undefined;

    this.serviceTimeMapByProgramType = {};
    const serviceTimeMapByProgramTypeMilis = {};
    this.overallDayTotals.forEach((d) => {

      _.forOwn(d.programTypeToDestinationServiceTime, (value, key) => {
        const programName = this.programTypesMap[key];

        if (!serviceTimeMapByProgramTypeMilis[programName]) {
          serviceTimeMapByProgramTypeMilis[programName] = 0;
        }
        serviceTimeMapByProgramTypeMilis[programName] += value;
      })
    })

    _.forOwn(serviceTimeMapByProgramTypeMilis, (value, key) => {
      const totalSeconds = Math.floor(value / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);

      this.serviceTimeMapByProgramType[key] = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    })

    this._setRoutesTotalTime(this.visitSchedule);

    if (getCphSummary) {
      this._getCphSummary();
    }

  }

  private _getCphSummary() {
    this.visitPlanHttpService.getTotalCph(this.visitPlan.id, this.visitPlan.scheduleId).subscribe((cphSummaryList: VisitPlanCphSummaryModel[]) => {
      const mainTags = ['FTSSR', 'FTSSROW', 'PTSSR', 'PTSSROW', 'sr SSR'];
      let mainTotalRoutesDurationSec = 0;

      cphSummaryList.forEach(summary => {
        if (mainTags.includes(summary.tag)) {
          mainTotalRoutesDurationSec += summary.totalRoutesDurationSec;
        }
      });

      this.mainCph = mainTotalRoutesDurationSec > 0
        ? Number((this.totalUnits / (mainTotalRoutesDurationSec / 3600)).toFixed(2))
        : 0;
    });
  }

  private _setRoutesTotalTime(visitSchedule) {
    const visitScheduleTotals = visitSchedule.totals;

    const totalTimeSec = visitScheduleTotals?.totalRoutesDurationSec || 0;

    const totalTravelTimeSec = visitScheduleTotals?.totalRoutesTravelTimeSec || 0;

    const totalServiceTimeSec = visitScheduleTotals?.totalRoutesServiceTimeSec || 0;

    const totalIdleTimeSec = Math.max(
      totalTimeSec - totalTravelTimeSec - totalServiceTimeSec,
      0
    );

    this.totalRouteTime = {
      planned: getFormattedTime(totalTimeSec),
      travelTime: getFormattedTime(totalTravelTimeSec),
      serviceTime: getFormattedTime(totalServiceTimeSec),
      idleTime: getFormattedTime(totalIdleTimeSec),
    }

    function getFormattedTime(timeInSec) {
      const hours = Math.floor(timeInSec / 3600);
      const minutes = Math.floor((timeInSec % 3600) / 60);
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }



  }

  private _getQueryWithLimitPayload() {
    const params = {
      query: this.filtersConfig.visitPlan.queryString,
      // from: this.filtersConfig.visitPlan.range.dateStart,
      // to: this.filtersConfig.visitPlan.range.dateEnd,
      areaIds: this.filtersConfig.visitPlan.bringozFilters.serviceAreaIds,
      branchIds: this.filtersConfig.visitPlan.bringozFilters.branchIds,
      accountIds: this.filtersConfig.visitPlan.bringozFilters.accountIds,
      segments: this._getSegmentsFilterValue(),
      states: this.filtersConfig.visitPlan.bringozFilters.states,
      sort: this._setQueryParamSort(),
      limit: 30
    }


    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
    return params;
  }

  private _getQueryTotalsWithLimitPayload() {
    const params = {
      query: this.filtersConfig.visitPlan.queryString,
      from: this.filtersConfig.visitPlan.range.dateStart,
      to: this.filtersConfig.visitPlan.range.dateEnd,
      areaIds: this.filtersConfig.visitPlan.bringozFilters.serviceAreaIds,
      branchIds: this.filtersConfig.visitPlan.bringozFilters.branchIds,
      accountIds: this.filtersConfig.visitPlan.bringozFilters.accountIds,
      segments: this._getSegmentsFilterValue(),
      states: this.filtersConfig.visitPlan.bringozFilters.states,
      sort: this._setQueryParamSort(),
      limit: 20
    }


    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
    return params;
  }

  private _getSegmentsFilterValue(): number[] | undefined {
    const segment = this.filtersConfig.visitPlan.bringozFilters[SiteFiltersType.segment];

    if (_.isNil(segment) || segment === '') {
      return undefined;
    }

    const parsedSegment = Number(segment);

    return Number.isNaN(parsedSegment) ? undefined : [parsedSegment];
  }

  private _setQueryParamSort() {
    return this.accountSortBy + ',' + this.accountSortByType;
  }

  private _setVisitSchedule(visitPlan: VisitPlanModel) {
    // this._getVisitSchedule();
    this._setVisitScheduleTimeline(visitPlan);
    this._getVisitScheduleDaysData(visitPlan);
  }

  private _getJobs(visitPlan) {
    const jobsQuery = {
      limit: 3000
    }
    this.visitPlanHttpService.getVisitPlanScheduleJobs(visitPlan.id, visitPlan.scheduleId, jobsQuery).subscribe((res) => {
      this.jobs = res.list;
      this.$timeout(() => {
      }, 0);
    })
  }

  private _getVisitSchedule() {

    if (!!this.visitScheduleSubscription) {
      this.visitScheduleSubscription.unsubscribe();
    }

    this.visitScheduleFacadeService.clearStore();
    this.visitScheduleFacadeService.getVisitSchedule(this.visitPlanId, this.visitPlan.scheduleId, true);

    // this.visitScheduleSubscription = this.visitPlanFacadeService.getVisitSchedule(this.visitPlanId, this.visitPlan.scheduleId)
    //   .subscribe((visitSchedule: VisitScheduleModel) => {
    //     this.visitSchedule = visitSchedule;
    //   })
  }

  private _getProjectVisitScheduleDaysData(visitPlan: VisitPlanModel) {
    const params = {
      from: this.filtersConfig.visitPlan.range.dateStart,
      to: this.filtersConfig.visitPlan.range.dateEnd
    }
    console.count('_getProjectVisitScheduleDaysData called');

    this.visitPlanFacadeService.getVisitScheduleDaysData(visitPlan.id, visitPlan.scheduleId, params)
      .subscribe((res: { list: VisitScheduleDayModel[], cursor: string }) => {
        this.projectVisitScheduleDays = res.list;
        this.visitScheduleDays = res.list;
        this.$timeout(() => {
        }, 0);
      })
  }

  private _getVisitScheduleDaysData(visitPlan: VisitPlanModel) {
    const params = {
      from: this.filtersConfig.visitPlan.range.dateStart,
      to: this.filtersConfig.visitPlan.range.dateEnd
    }
    console.count('_getVisitScheduleDaysData called');

    this.visitPlanFacadeService.getVisitScheduleDaysData(visitPlan.id, visitPlan.scheduleId, params)
      .subscribe((res: { list: VisitScheduleDayModel[], cursor: string }) => {
        this.visitScheduleDays = res.list;
        this._setPublishState();
        this.$timeout(() => {
        }, 0);
      })
  }

  private _getSchedulingProjectDays(visitPlan: VisitPlanModel) {
    this.visitPlanFacadeService.getVisitScheduleDaysData(visitPlan.id, visitPlan.scheduleId, {})
      .subscribe((res: { list: VisitScheduleDayModel[], cursor: string }) => {
        this.schedulingProjectDays = res.list;
        this._setPublishState();
        this.$timeout(() => {
        }, 0);
      })
  }

  private _setVisitScheduleTimeline(visitPlan) {
    // this.paginationData = undefined;
    console.count('_setVisitScheduleTimeline called');

    if (this.resourceHoldersPaginationData) {
      this.resourceHoldersPaginationData.content = undefined;
    }
    const params: VisitScheduleResourceHoldersParamsModel = this._getResourceHoldersQuery();
    this.visitPlanFacadeService.getResourceHolders(visitPlan.id, visitPlan.scheduleId, params)
      .subscribe((paginationData: ResourceHoldersPaginationDataModel) => {
        this.resourceHoldersPaginationData = paginationData;

        if (!!this.resourceHoldersPaginationData?.content.length) this.initAgentColorMap();

        let pages = [];
        _.times(paginationData.totalPages, (i) => {
          pages.push(i);
        });

        this.agentsPaginationPages = pages;

        if (this.isMapView) {
          this._setMapRoutes();
        }
        this._setViewData();
      })
  }

  private _getResourceHoldersQuery() {
    const queryPayload: VisitScheduleResourceHoldersParamsModel = {
      projectBranchIds: !!this.filtersConfig.visitSchedule.bringozFilters.branchIds?.length ? this.filtersConfig.visitSchedule.bringozFilters.branchIds : undefined,
      // noArea?: boolean;
      // skill: this.filtersConfig.visitSchedule.bringozFilters.agentSkills,
      query: this.filtersConfig.visitSchedule.queryString,
      holderIds: (this.filtersConfig.visitSchedule.bringozFilters.agentIds.length ? this.filtersConfig.visitSchedule.bringozFilters.agentIds : undefined),
      agentTags: this.filtersConfig.visitSchedule.bringozFilters.tags,
      excludeResources: true,
      external: this.filtersConfig.visitSchedule.bringozFilters.agentSource,
      // vehicleId?: string[];
      // registrationStatusActive?: boolean; // default true
      page: this.filtersConfig.visitSchedule.page || 0, // default 0
      size: this.visitScheduleSize || 20, // default 20
      sort: ["holderName,asc"]
      // sort:  ["fullName,asc"]
      // sort: this.isSortMode ? ['fullName,asc'] : undefined
    };

    // if (!!group) {
    //   if (_.isEqual(group, 'Active')) {
    //     queryPayload.group = group;
    //     // queryPayload.status = 'OnDuty';
    //   }
    //   if (_.isEqual(group, 'OffDuty')) {
    //     queryPayload.status = group;
    //   }
    // }
    return  _.omitBy(queryPayload, _.isUndefined)
  }

  private _setViewData() {

    console.count('_setViewData called');

    if (!!this.visitScheduleResourcesSubscription) {
      this.visitScheduleResourcesSubscription.unsubscribe();
      this.visitScheduleResourcesSubscription = undefined;
    }

    this.resources = [];
    // this.routes = [];

    const displayedAgentsIds = _.map(this.resourceHoldersPaginationData?.content, 'id');

    if (displayedAgentsIds && displayedAgentsIds.length) {
      this._getResources(displayedAgentsIds);
      this._getRoutes();
    }
  }

  private _getResources(resourceHolderIds) {

    // Cross Day Support
    const fromDay = this.moment(this.moment(this.filtersConfig.visitSchedule.range.dateStart).format("MM/DD/YYYY")).isSame(this.moment(this.visitPlan.from).format("MM/DD/YYYY")) ?
      this.filtersConfig.visitSchedule.range.dateStart :
      this.moment(this.filtersConfig.visitSchedule.range.dateStart).subtract(1, 'days').startOf('day').valueOf();

    const resourceQuery: VisitScheduleResourcesParamsModel = {
      from: fromDay,
      to: this.filtersConfig.visitSchedule.range.dateEnd,
      limit: 1000,
      resourceHolderIds: resourceHolderIds
    };

    console.count('_getResources called');

    this.visitScheduleResourcesSubscription = this.visitPlanFacadeService.getResources(this.visitPlanId, this.visitPlan.scheduleId, resourceQuery)
      .subscribe((res) => {
        this.resources = res.list;
        this.$timeout(() => {
        }, 0);
      })
  }

  private _filterRoutesByRange(routes: any[]): any[] {
    const range = this.filtersConfig?.visitSchedule?.range;
    if (!range?.dateStart || !range?.dateEnd) {
      return routes;
    }

    return routes.filter(route => {
      if (!route.activities || route.activities.length === 0) return true;

      const routeFrom: any = route.activities[0].eta;
      const routeTo: any = route.activities[route.activities.length - 1].etd;

      const isRouteFromInRange = this._isDateInRange(routeFrom, range.dateStart, range.dateEnd);
      const isRouteToInRange = this._isDateInRange(routeTo, range.dateStart, range.dateEnd);
      const isVisitPlanInRange = this._isDateInRange(range.dateStart, routeFrom, routeTo);

      return isRouteFromInRange || isRouteToInRange || isVisitPlanInRange;
    });
  }

  private _isDateInRange(targetTs: number, startTs: number, endTs: number): boolean {
    const normalize = (ts: number) => {
      const d = new Date(ts);
      return new Date(
        d.getFullYear(),
        d.getMonth(),
        d.getDate()
      ).getTime();
    };

    const target = normalize(targetTs);
    const start = normalize(startTs);
    const end = normalize(endTs);

    return target >= start && target <= end;
  }

  private _getRoutes() {
    // const displayedAgentsIds = _.map(this.resourceHoldersPaginationData.content, 'id');

    // Cross Day Support
    const fromDay = this.moment(this.moment(this.filtersConfig.visitSchedule.range.dateStart).format("MM/DD/YYYY")).isSame(this.moment(this.visitPlan.from).format("MM/DD/YYYY")) ?
      this.filtersConfig.visitSchedule.range.dateStart :
      this.moment(this.filtersConfig.visitSchedule.range.dateStart).subtract(1, 'days').startOf('day').valueOf();

    const routesQuery = {
      from: fromDay,
      to: this.filtersConfig.visitSchedule.range.dateEnd,
      projectBranchIds: this.filtersConfig.visitPlan.bringozFilters.branchIds,
      // agentIds: displayedAgentsIds,
      limit: 3000
    }

    this.visitPlanRoutes = [];
    this.selectedRouteIds = [];
    this.isLoadingRoutes = true;

    console.count('_getRoutes called');

    this.visitPlanScheduleFacadeService.getVisitScheduleRoutesCursor(this.visitPlanId, this.visitPlan.scheduleId, routesQuery)
      .subscribe((res) => {
        // this.visitPlanRoutes = res.list;
        this.visitPlanRoutes = this._getSortedRoutes(this._filterRoutesByRange(res.list));
        this.isLoadingRoutes = false;
        if (!this.routesSubscription) {
          this.initRoutesSubscriptions();
        }

        if (this.isMapView) {
          this._setMapRoutes();
        }

        if (this.visitPlan.resourcesImportCompleted && this.visitPlan.slotsImportCompleted) {
          this._getResourcesUtilization();
        }

        this._getVisitScheduleRisks();

        this.$timeout(() => {
        }, 0);
      })
  }

  private _updateRoutesByIds(ids: string[]) {
    const routesQuery = {
      ids: ids
    }
    this.visitPlanScheduleFacadeService.getVisitScheduleRoutesCursor(this.visitPlanId, this.visitPlan.scheduleId, routesQuery)
      .subscribe((res) => {
        this.visitPlanRoutes = this._getSortedRoutes(
          _.unionBy(res.list, this.visitPlanRoutes, 'id')
        )

        this.$timeout(() => {
        }, 0);
      })
  }

  private _getResourcesUtilization() {
    const resourceHolderIds = _.map(this.resourceHoldersPaginationData?.content, 'id');

    const query = {
      from: this.visitPlan.from,
      to: this.visitPlan.to,
      resourceHolderIds: resourceHolderIds
    }

    this.resourcesUtilization = [];
    console.count('_getResourcesUtilization called');

    this.visitPlanScheduleFacadeService.getVisitScheduleAgentsUtilization(this.visitPlanId, this.visitPlan.scheduleId, query)
      .subscribe((res) => {
        this.resourcesUtilization = res.list || res;
        this.$timeout(() => {
        }, 0);
      })
  }

  private _getVisitScheduleRisks() {
    const resourceHolderIds = _.map(this.resourceHoldersPaginationData?.content, 'id');

    const query = {
      // from: this.visitPlan.from,
      // to: this.visitPlan.to,
      resourceHolderIds: resourceHolderIds
      // holderIds: displayedAgentsIds
    }

    this.visitScheduleAnalysis = undefined;
    this.visitPlanScheduleFacadeService.getVisitScheduleRisks(this.visitPlanId, this.visitPlan.scheduleId, query)
      .subscribe((visitScheduleAnalysis: VisitScheduleAnalysisModel) => {
        this.visitScheduleAnalysis = visitScheduleAnalysis;
        this.$timeout(() => {
        }, 0);
      })
  }

  private _getResourceConflictData(): Observable<{ resources: VisitScheduleResourceModel[], conflictSet: Set<string> }> {
    const query = { from: this.visitPlan.from, to: this.visitPlan.to };
    return forkJoin([
      this.visitPlanHttpService.getResourcesList(this.visitPlanId, this.visitPlan.scheduleId, query),
      this.visitPlanHttpService.getResourceConflicts(this.visitPlanId, this.visitPlan.scheduleId, query)
    ]).pipe(
      map(([resources, conflictIds]) => ({ resources, conflictSet: new Set(conflictIds) }))
    );
  }

  // All agents with any conflicting resource anywhere in the schedule — used to populate the
  // availability dialog's employee filter (both the timeline icon click and "Go To Availability"),
  // so the user can review/fix every conflict, including ones already partially solved.
  private _getAllConflictingResourceHolderIds(): Observable<string[]> {
    return this._getResourceConflictData().pipe(
      map(({ resources, conflictSet }) => {
        // The availability dialog's employee filter (filterEmployeeIds -> holderIds) is keyed by
        // the underlying agent id, not the resource-holder wrapper's own id (resourceHolderId).
        return _.uniq(resources.filter(r => conflictSet.has(r.id)).map(r => r.agentId));
      })
    );
  }

  // Agents whose conflict is NOT yet solved (no valid replacement availability alongside it for
  // that same day) — used to decide whether publish should be blocked at all. A conflict only
  // counts here if the conflicting availability actually has a route on it; a conflict on a
  // routeless availability has nothing to clash with, so it shouldn't block publish.
  private _getBlockingConflictResourceHolderIds(): Observable<string[]> {
    return this._getResourceConflictData().pipe(
      map(({ resources, conflictSet }) => {
        const resourceIdsWithRoutes = new Set<string>();
        (this.visitPlanRoutes || []).forEach(route => {
          if (route.resource?.id) {
            resourceIdsWithRoutes.add(route.resource.id);
          }
        });

        // Group by resource-holder + day (mirroring the availability grid's own bucketing) so a
        // conflicting resource that already has a valid replacement availability alongside it for
        // that same day/agent is treated as solved, and doesn't keep blocking publish.
        const groups = new Map<string, VisitScheduleResourceModel[]>();
        resources.forEach(r => {
          const key = `${r.resourceHolderId}_${r.visitScheduleDayId}`;
          if (!groups.has(key)) {
            groups.set(key, []);
          }
          groups.get(key).push(r);
        });

        const blockingAgentIds: string[] = [];
        groups.forEach(groupResources => {
          if (isVisitScheduleDayDispatchedById(this.visitScheduleDays, groupResources[0].visitScheduleDayId)) {
            return;
          }
          const hasConflict = groupResources.some(r => conflictSet.has(r.id) && resourceIdsWithRoutes.has(r.id));
          const hasValidAvailability = groupResources.some(r => !conflictSet.has(r.id));
          if (hasConflict && !hasValidAvailability) {
            blockingAgentIds.push(groupResources[0].agentId);
          }
        });

        return _.uniq(blockingAgentIds);
      })
    );
  }

  onOpenConflictAvailability(event?, onlyBlocking: boolean = false) {
    // Reached from the timeline conflict icon, which opens the editable availability dialog
    if (this.isActionBlocked()) return;

    const resourceHolderIds$ = onlyBlocking
      ? this._getBlockingConflictResourceHolderIds()
      : this._getAllConflictingResourceHolderIds();
    resourceHolderIds$.subscribe(resourceHolderIds => {
      this.schedulingProjectDialogService.showAvailabilityDialog(
        this.visitPlan,
        this.visitPlan.scheduleId,
        this.visitPlan.branchIds,
        this.filtersConfig.visitSchedule.range.dateStart,
        this.filtersConfig.visitSchedule.range.dateEnd,
        this.visitPlan.zoneId,
        event,
        resourceHolderIds
      ).then((data) => {
        if (data?.success && data.resources?.length) {
          this._mergeUpdatedResources(data.resources);
          this.onManualRefreshRoutes();
        }
        if (data?.refreshSchedule) {
          this._setVisitScheduleTimeline(this.visitPlan);
        }
      });
    });
  }

  private _initVisitScheduleSubscription() {
    if (this.visitScheduleSubscription) {
      this.visitScheduleSubscription.unsubscribe();
    }
    this.visitScheduleSubscription = this.visitScheduleFacadeService.selectOne(this.visitPlan.scheduleId)
      .subscribe((visitSchedule: VisitScheduleModel) => {
        console.count('visitScheduleSubscription emitted');

        if (!!visitSchedule) {
          if (visitSchedule.status === this.visitScheduleStatuses.Processing) {
            this.schedulingProjectDialogService.visitScheduleProcessingDialog(this.visitPlan, visitSchedule);
          }

          if (this.visitSchedule?.status === this.visitScheduleStatuses.Processing && visitSchedule.status === this.visitScheduleStatuses.Ongoing) {
            this._getRoutes();
            // this._syncVisitSchedule();
            this._syncVisitPlanAccountAnalysis();
            this._getJobs(this.visitPlan);
          }

          if (this.visitSchedule && (this.visitSchedule.totalsUpdatedAt < visitSchedule.totalsUpdatedAt)) {
            this._getVisitScheduleDaysData(this.visitPlan);
          }

          let hasTotalDurationChanged = false;
          if (!!this.visitSchedule && (this.visitSchedule['totals']?.totalRoutesDurationSec !== visitSchedule['totals']?.totalRoutesDurationSec)) {
            hasTotalDurationChanged = true;
          }

          // if (!this.visitSchedule?.editedAfterPublish && visitSchedule.editedAfterPublish) {
          //   this.schedulingProjectDialogService.showEditedAfterPublishDialog();
          // }

          this.visitSchedule = _.cloneDeep(visitSchedule);
          this._syncAutoDispatchUiFromVisitSchedule();
          // calc totals for CPH when visit schedule updates (contains totalDurationinSec)
          this._calculateTotals(hasTotalDurationChanged);
          this.$timeout(() => {
          }, 0);
        }
      });

    if (this.visitScheduleLoadingStateSubscription) {
      this.visitScheduleLoadingStateSubscription.unsubscribe();
    }
    this.visitScheduleLoadingStateSubscription = this.visitScheduleFacadeService.selectIsLoading().subscribe((isLoading: boolean) => {

      console.count('visitScheduleLoadingStateSubscription emitted');

      this.isLoadingVisitSchedule = isLoading;
      this.$timeout(() => {
      }, 0);
    });

    this.visitScheduleFacadeService.subscribeToChannels();
  }

  private _syncVisitPlanAccountAnalysis() {
    const accountIds = this.accounts?.map(a => a.accountId).filter(Boolean);
    if (!accountIds?.length) {
      return;
    }
    const params = {
      accountIds: accountIds,
      limit: 30,
      states: this.filtersConfig.visitPlan.bringozFilters.states
    };

    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
    this.visitPlanAccountFacadeService.getVisitPlanAccountAnalysis(this.visitPlanId, params);
  }

  public initRoutesSubscriptions() {
    if (!this.routesSubscription) {
      this.routesSubscription = this.visitScheduleRoutesChannelService.subscribeChannel().pipe(skip(1))
        .subscribe((res: any) => {
          console.count('routesSubscription emitted');

          if (res.action === 'created') {
            console.count('routesSubscription action created');
            let routesToAdd = [];

            res.list?.forEach((r) => {
              if (_.includes(r.visitScheduleIds, this.visitSchedule?.id)) {
                routesToAdd.push(r);
              }
            })

            routesToAdd = this._filterRoutesByRange(routesToAdd);

            if (!!routesToAdd.length) {
              this.visitPlanRoutes = this._getSortedRoutes(
                _.unionBy(this.visitPlanRoutes, routesToAdd, 'id')
              )

              if (this.isMapView) {
                this._setMapRoutes();
              }
            }
          } else if (res.action === 'changed') {
            console.count('routesSubscription action changed');

            const routesToUpdate = [];
            const routesToDelete = [];

            res.list.forEach((r) => {
              const indexToUpdate = _.findIndex(this.visitPlanRoutes, (pr) => {
                return pr.id === r.id;
              })

              if (r.deleted && indexToUpdate > -1) {
                routesToDelete.push(r);
              }

              if (!r.deleted && indexToUpdate > -1) {
                routesToUpdate.push(r);
              }
            })

            // Delete Routes
            if (routesToDelete.length) {
              const idsToDelete = _.map(routesToDelete, 'id');
              this.visitPlanRoutes = this.visitPlanRoutes.filter((r) => {
                return !_.includes(idsToDelete, r.id);
              });
            }

            // Update Routes
            if (routesToUpdate.length) {
              this.visitPlanRoutes = this._getSortedRoutes(
                _.unionBy(routesToUpdate, this.visitPlanRoutes, 'id')
              )
              // this._updateRoutesByIds(_.map(routesToUpdate, 'id')); // Hack for server not pushing bundles
            }


            if (routesToUpdate.length || routesToDelete.length) {

              if (this.isMapView) {
                this._setMapRoutes();
              }
            }

          }
        })
    }
  }

  private _openReassignRoutePanel(routeId: string, event: MouseEvent) {
    // Reached from a context menu selection, so the project may have been deleted in the meantime
    if (this.isActionBlocked() || this.visitPlan?.hasNotSyncedChanges) {
      return;
    }

    const route = this.visitPlanRoutes.find(route => route.id === routeId);
    const visitScheduleDayId = route?.visitScheduleDayId;
    const visitScheduleDay = this.visitScheduleDays?.find(d => d.id === visitScheduleDayId);

    if (isVisitScheduleDayDispatched(visitScheduleDay)) {
      this.schedulingProjectAlertsService.reassignRouteDayDispatchedError();
      return;
    }

    const dateRange = visitScheduleDay ? {
      from: this.moment(visitScheduleDay.date).startOf('day').valueOf(),
      to: this.moment(visitScheduleDay.date).endOf('day').valueOf()
    } : undefined;
    this.bringozLoaderService.on();
    this.visitPlanScheduleFacadeService.getAssignOptions(this.visitPlanId, this.visitSchedule.id, null, null, routeId, {filterOutRoutedResources: true})
      .pipe(finalize(() => this.bringozLoaderService.off()))
      .subscribe({
        next: (resources) => {
          const panel = this.panelService.open(VisitPlanScheduleRouteReassignmentComponent,
            event,
            {
              resources,
              visitPlan: this.visitPlan,
              visitScheduleId: this.visitSchedule.id,
              dateRange
            },
            {
              position: {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'top',
              },
              height: 370,
              width: 600
            });
          if (panel) {
            this._reassignRoutePanelSubscription?.unsubscribe();
            this._reassignRoutePanelSubscription = panel.afterClose$.subscribe(resourceId => {
              if(resourceId) {
                this.bringozLoaderService.on();
                this.visitPlanScheduleFacadeService.moveRoute(this.visitPlanId, this.visitSchedule.id, routeId, resourceId, visitScheduleDayId)
                  .pipe(finalize(() => this.bringozLoaderService.off()))
                  .subscribe({
                    next: (updatedRoutes) => {
                      if (!updatedRoutes) {
                        this.schedulingProjectAlertsService.reassignRouteError();
                        return;
                      }
                      let copyRoutes = this.visitPlanRoutes.filter(route => route.id !== routeId);
                      copyRoutes = [...updatedRoutes, ...copyRoutes];
                      this.visitPlanRoutes = angular.copy(copyRoutes);
                      this.bringozToastService.success({body: 'REASSIGN_ROUTE_SUCCESS'})
                      this.$timeout(() => {}, 0);
                    },
                    error: (error) => {
                      if (error?.status === 412 || error?.error?.code === 412205) {
                        this.schedulingProjectAlertsService.reassignRouteDayDispatchedError();
                      } else {
                        this.schedulingProjectAlertsService.reassignRouteError();
                      }
                    }
                  })
              }
            });
          }
        },
        error: (err) => {
          if(err.status === 404) {
            this.bringozToastService.error({body: 'REASSIGN_ROUTE_NO_AVAILABLE_AGENTS'})
          }
          if(err.status === 412) {
            if(err.error.code === 412205) {
              this.bringozToastService.error({body: 'REASSIGN_ROUTE_NO_CALL_IDS'})
            }
          }
        }
      })
  }

  private _isRouteDayDispatched(routeId: string): boolean {
    const route = this.visitPlanRoutes?.find(r => r.id === routeId);
    return isVisitScheduleDayDispatchedById(this.visitScheduleDays, route?.visitScheduleDayId);
  }

  private _areJobsOnDispatchedDay(jobIds: string[]): boolean {
    return !!jobIds?.some(jobId => {
      const job = _.find(this.jobs, (j) => j.id === jobId);
      return isVisitScheduleDayDispatchedById(this.visitScheduleDays, job?.visitScheduleDayId);
    });
  }

  private _hasSkillMismatch(jobIds: string[], allocationSkills: any): boolean {
    const itemJobs = _.filter(this.jobs, (j) => _.includes(jobIds, j.id));
    const itemSkills = _.flatMap(itemJobs, (j) => j.skills || []);
    return !!(allocationSkills && _.difference(itemSkills, allocationSkills).length);
  }

  private _getSortedRoutes(routes) {
    return _.sortBy(routes, route =>
      route.name || (route?.resource?.agentName?.toLowerCase() || '')
    );
  }

  private _syncVisitPlanAndScheduleFilters(filters) {
    this.filtersConfig.visitSchedule.bringozFilters[SiteFiltersType.branchIds] = filters[SiteFiltersType.branchIds];
    this.filtersConfig.visitPlan.bringozFilters[SiteFiltersType.branchIds] = filters[SiteFiltersType.branchIds];
  }

  private _isSyncVisitPlanAndScheduleFiltersNeeded() {
    return !_.isEqual(this.filtersConfig.visitSchedule.bringozFilters[SiteFiltersType.branchIds], this.filtersConfig.visitPlan.bringozFilters[SiteFiltersType.branchIds]);
  }

}

angular
  .module('bringoz.admin.scheduling-project')
  .component('visitPlanView', {
    bindings: {
      visitPlanId: '<',
      selectedQuickFilterId: '<?',
      visitScheduleFrom: '<?',
      visitScheduleTo: '<?',
      visitScheduleSize: '<?',
      visitSchedulePage: '<?',
      // visitPlanRoutes: '<?',
      jobs: '<?',
    },
    template: require('./visit-plan-view.html').default,
    controller: VisitPlanViewComponent
  });
